!function(t, e) {
    "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.AOS = e() : t.AOS = e()
}(this, function() {
    return o = {},
    i.m = n = [function(t, e, i) {
        "use strict";
        function n(t) {
            return t && t.__esModule ? t : {
                default: t
            }
        }
        function o() {
            if (0 < arguments.length && void 0 !== arguments[0] && arguments[0] && (g = !0),
            g)
                return m = (0,
                p.default)(m, y),
                (0,
                h.default)(m, y.once),
                m
        }
        function r() {
            m = (0,
            f.default)(),
            o()
        }
        var s = Object.assign || function(t) {
            for (var e = 1; e < arguments.length; e++) {
                var i, n = arguments[e];
                for (i in n)
                    Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i])
            }
            return t
        }
          , a = (n(i(1)),
        i(6))
          , l = n(a)
          , c = n(i(7))
          , u = n(i(8))
          , d = n(i(9))
          , h = n(i(10))
          , p = n(i(11))
          , f = n(i(14))
          , m = []
          , g = !1
          , v = document.all && !window.atob
          , y = {
            offset: 120,
            delay: 0,
            easing: "ease",
            duration: 400,
            disable: !1,
            once: !1,
            startEvent: "DOMContentLoaded",
            disableMutationObserver: !1
        };
        t.exports = {
            init: function(t) {
                return y = s(y, t),
                m = (0,
                f.default)(),
                !0 === (t = y.disable) || "mobile" === t && d.default.mobile() || "phone" === t && d.default.phone() || "tablet" === t && d.default.tablet() || "function" == typeof t && !0 === t() || v ? void m.forEach(function(t, e) {
                    t.node.removeAttribute("data-aos"),
                    t.node.removeAttribute("data-aos-easing"),
                    t.node.removeAttribute("data-aos-duration"),
                    t.node.removeAttribute("data-aos-delay")
                }) : (document.querySelector("body").setAttribute("data-aos-easing", y.easing),
                document.querySelector("body").setAttribute("data-aos-duration", y.duration),
                document.querySelector("body").setAttribute("data-aos-delay", y.delay),
                "DOMContentLoaded" === y.startEvent && -1 < ["complete", "interactive"].indexOf(document.readyState) ? o(!0) : ("load" === y.startEvent ? window : document).addEventListener(y.startEvent, function() {
                    o(!0)
                }),
                window.addEventListener("resize", (0,
                c.default)(o, 50, !0)),
                window.addEventListener("orientationchange", (0,
                c.default)(o, 50, !0)),
                window.addEventListener("scroll", (0,
                l.default)(function() {
                    (0,
                    h.default)(m, y.once)
                }, 99)),
                y.disableMutationObserver || (0,
                u.default)("[data-aos]", r),
                m)
            },
            refresh: o,
            refreshHard: r
        }
    }
    , function(t, e) {}
    , , , , , function(p, t) {
        (function(t) {
            "use strict";
            function r(n, i, t) {
                function o(t) {
                    var e = l
                      , i = c;
                    return l = c = void 0,
                    f = t,
                    d = n.apply(i, e)
                }
                function r(t) {
                    var e = t - p;
                    return void 0 === p || i <= e || e < 0 || g && u <= t - f
                }
                function s() {
                    var t, e = x();
                    return r(e) ? a(e) : void (h = setTimeout(s, (t = i - (e - p),
                    g ? E(t, u - (e - f)) : t)))
                }
                function a(t) {
                    return h = void 0,
                    v && l ? o(t) : (l = c = void 0,
                    d)
                }
                function e() {
                    var t = x()
                      , e = r(t);
                    if (l = arguments,
                    c = this,
                    p = t,
                    e) {
                        if (void 0 === h)
                            return f = e = p,
                            h = setTimeout(s, i),
                            m ? o(e) : d;
                        if (g)
                            return h = setTimeout(s, i),
                            o(p)
                    }
                    return void 0 === h && (h = setTimeout(s, i)),
                    d
                }
                var l, c, u, d, h, p, f = 0, m = !1, g = !1, v = !0;
                if ("function" != typeof n)
                    throw new TypeError(w);
                return i = b(i) || 0,
                y(t) && (m = !!t.leading,
                u = (g = "maxWait"in t) ? S(b(t.maxWait) || 0, i) : u,
                v = "trailing"in t ? !!t.trailing : v),
                e.cancel = function() {
                    void 0 !== h && clearTimeout(h),
                    l = p = c = h = void (f = 0)
                }
                ,
                e.flush = function() {
                    return void 0 === h ? d : a(x())
                }
                ,
                e
            }
            function y(t) {
                var e = void 0 === t ? "undefined" : n(t);
                return t && ("object" == e || "function" == e)
            }
            function b(t) {
                if ("number" == typeof t)
                    return t;
                if ("symbol" == (void 0 === (e = t) ? "undefined" : n(e)) || e && "object" == (void 0 === e ? "undefined" : n(e)) && h.call(e) == s)
                    return o;
                var e;
                if (y(t) && (t = y(i = "function" == typeof t.valueOf ? t.valueOf() : t) ? i + "" : i),
                "string" != typeof t)
                    return 0 === t ? t : +t;
                t = t.replace(a, "");
                var i = c.test(t);
                return i || u.test(t) ? d(t.slice(2), i ? 2 : 8) : l.test(t) ? o : +t
            }
            function x() {
                return i.Date.now()
            }
            var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t
            }
            : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
            }
              , w = "Expected a function"
              , o = NaN
              , s = "[object Symbol]"
              , a = /^\s+|\s+$/g
              , l = /^[-+]0x[0-9a-f]+$/i
              , c = /^0b[01]+$/i
              , u = /^0o[0-7]+$/i
              , d = parseInt
              , e = "object" == (void 0 === t ? "undefined" : n(t)) && t && t.Object === Object && t
              , t = "object" == ("undefined" == typeof self ? "undefined" : n(self)) && self && self.Object === Object && self
              , i = e || t || Function("return this")()
              , h = Object.prototype.toString
              , S = Math.max
              , E = Math.min;
            p.exports = function(t, e, i) {
                var n = !0
                  , o = !0;
                if ("function" != typeof t)
                    throw new TypeError(w);
                return y(i) && (n = "leading"in i ? !!i.leading : n,
                o = "trailing"in i ? !!i.trailing : o),
                r(t, e, {
                    leading: n,
                    maxWait: e,
                    trailing: o
                })
            }
        }
        ).call(t, function() {
            return this
        }())
    }
    , function(h, t) {
        (function(t) {
            "use strict";
            function y(t) {
                var e = void 0 === t ? "undefined" : n(t);
                return t && ("object" == e || "function" == e)
            }
            function b(t) {
                if ("number" == typeof t)
                    return t;
                if ("symbol" == (void 0 === (e = t) ? "undefined" : n(e)) || e && "object" == (void 0 === e ? "undefined" : n(e)) && d.call(e) == r)
                    return o;
                var e;
                if (y(t) && (t = y(i = "function" == typeof t.valueOf ? t.valueOf() : t) ? i + "" : i),
                "string" != typeof t)
                    return 0 === t ? t : +t;
                t = t.replace(s, "");
                var i = l.test(t);
                return i || c.test(t) ? u(t.slice(2), i ? 2 : 8) : a.test(t) ? o : +t
            }
            function x() {
                return i.Date.now()
            }
            var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t
            }
            : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
            }
              , o = NaN
              , r = "[object Symbol]"
              , s = /^\s+|\s+$/g
              , a = /^[-+]0x[0-9a-f]+$/i
              , l = /^0b[01]+$/i
              , c = /^0o[0-7]+$/i
              , u = parseInt
              , e = "object" == (void 0 === t ? "undefined" : n(t)) && t && t.Object === Object && t
              , t = "object" == ("undefined" == typeof self ? "undefined" : n(self)) && self && self.Object === Object && self
              , i = e || t || Function("return this")()
              , d = Object.prototype.toString
              , w = Math.max
              , S = Math.min;
            h.exports = function(n, i, t) {
                function o(t) {
                    var e = l
                      , i = c;
                    return l = c = void 0,
                    f = t,
                    d = n.apply(i, e)
                }
                function r(t) {
                    var e = t - p;
                    return void 0 === p || i <= e || e < 0 || g && u <= t - f
                }
                function s() {
                    var t, e = x();
                    return r(e) ? a(e) : void (h = setTimeout(s, (t = i - (e - p),
                    g ? S(t, u - (e - f)) : t)))
                }
                function a(t) {
                    return h = void 0,
                    v && l ? o(t) : (l = c = void 0,
                    d)
                }
                function e() {
                    var t = x()
                      , e = r(t);
                    if (l = arguments,
                    c = this,
                    p = t,
                    e) {
                        if (void 0 === h)
                            return f = e = p,
                            h = setTimeout(s, i),
                            m ? o(e) : d;
                        if (g)
                            return h = setTimeout(s, i),
                            o(p)
                    }
                    return void 0 === h && (h = setTimeout(s, i)),
                    d
                }
                var l, c, u, d, h, p, f = 0, m = !1, g = !1, v = !0;
                if ("function" != typeof n)
                    throw new TypeError("Expected a function");
                return i = b(i) || 0,
                y(t) && (m = !!t.leading,
                u = (g = "maxWait"in t) ? w(b(t.maxWait) || 0, i) : u,
                v = "trailing"in t ? !!t.trailing : v),
                e.cancel = function() {
                    void 0 !== h && clearTimeout(h),
                    l = p = c = h = void (f = 0)
                }
                ,
                e.flush = function() {
                    return void 0 === h ? d : a(x())
                }
                ,
                e
            }
        }
        ).call(t, function() {
            return this
        }())
    }
    , function(t, e) {
        "use strict";
        function n(t) {
            t && t.forEach(function(t) {
                var e = Array.prototype.slice.call(t.addedNodes)
                  , t = Array.prototype.slice.call(t.removedNodes);
                e.concat(t).filter(function(t) {
                    return t.hasAttribute && t.hasAttribute("data-aos")
                }).length && s()
            })
        }
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        var o = window.document
          , r = window.MutationObserver || window.WebKitMutationObserver
          , s = function() {};
        e.default = function(t, e) {
            var i = new r(n);
            s = e,
            i.observe(o.documentElement, {
                childList: !0,
                subtree: !0,
                removedNodes: !0
            })
        }
    }
    , function(t, e) {
        "use strict";
        function i() {
            return navigator.userAgent || navigator.vendor || window.opera || ""
        }
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        var n = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
          , o = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
          , r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i
          , s = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
          , a = (function(t, e, i) {
            return e && c(t.prototype, e),
            i && c(t, i),
            t
        }(l, [{
            key: "phone",
            value: function() {
                var t = i();
                return !(!n.test(t) && !o.test(t.substr(0, 4)))
            }
        }, {
            key: "mobile",
            value: function() {
                var t = i();
                return !(!r.test(t) && !s.test(t.substr(0, 4)))
            }
        }, {
            key: "tablet",
            value: function() {
                return this.mobile() && !this.phone()
            }
        }]),
        l);
        function l() {
            !function(t) {
                if (!(t instanceof l))
                    throw new TypeError("Cannot call a class as a function")
            }(this)
        }
        function c(t, e) {
            for (var i = 0; i < e.length; i++) {
                var n = e[i];
                n.enumerable = n.enumerable || !1,
                n.configurable = !0,
                "value"in n && (n.writable = !0),
                Object.defineProperty(t, n.key, n)
            }
        }
        e.default = new a
    }
    , function(t, e) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: !0
        }),
        e.default = function(t, r) {
            var s = window.pageYOffset
              , a = window.innerHeight;
            t.forEach(function(t, e) {
                var i, n, o;
                n = a + s,
                o = r,
                t = (i = t).node.getAttribute("data-aos-once"),
                n > i.position ? i.node.classList.add("aos-animate") : void 0 === t || "false" !== t && (o || "true" === t) || i.node.classList.remove("aos-animate")
            })
        }
    }
    , function(t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        var n = (i = i(12)) && i.__esModule ? i : {
            default: i
        };
        e.default = function(t, i) {
            return t.forEach(function(t, e) {
                t.node.classList.add("aos-init"),
                t.position = (0,
                n.default)(t.node, i.offset)
            }),
            t
        }
    }
    , function(t, e, i) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: !0
        });
        var s = (i = i(13)) && i.__esModule ? i : {
            default: i
        };
        e.default = function(t, e) {
            var i = 0
              , n = 0
              , o = window.innerHeight
              , r = {
                offset: t.getAttribute("data-aos-offset"),
                anchor: t.getAttribute("data-aos-anchor"),
                anchorPlacement: t.getAttribute("data-aos-anchor-placement")
            };
            switch (r.offset && !isNaN(r.offset) && (n = parseInt(r.offset)),
            r.anchor && document.querySelectorAll(r.anchor) && (t = document.querySelectorAll(r.anchor)[0]),
            i = (0,
            s.default)(t).top,
            r.anchorPlacement) {
            case "top-bottom":
                break;
            case "center-bottom":
                i += t.offsetHeight / 2;
                break;
            case "bottom-bottom":
                i += t.offsetHeight;
                break;
            case "top-center":
                i += o / 2;
                break;
            case "bottom-center":
                i += o / 2 + t.offsetHeight;
                break;
            case "center-center":
                i += o / 2 + t.offsetHeight / 2;
                break;
            case "top-top":
                i += o;
                break;
            case "bottom-top":
                i += t.offsetHeight + o;
                break;
            case "center-top":
                i += t.offsetHeight / 2 + o
            }
            return r.anchorPlacement || r.offset || isNaN(e) || (n = e),
            i + n
        }
    }
    , function(t, e) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: !0
        }),
        e.default = function(t) {
            for (var e = 0, i = 0; t && !isNaN(t.offsetLeft) && !isNaN(t.offsetTop); )
                e += t.offsetLeft - ("BODY" != t.tagName ? t.scrollLeft : 0),
                i += t.offsetTop - ("BODY" != t.tagName ? t.scrollTop : 0),
                t = t.offsetParent;
            return {
                top: i,
                left: e
            }
        }
    }
    , function(t, e) {
        "use strict";
        Object.defineProperty(e, "__esModule", {
            value: !0
        }),
        e.default = function(t) {
            t = t || document.querySelectorAll("[data-aos]");
            var i = [];
            return [].forEach.call(t, function(t, e) {
                i.push({
                    node: t
                })
            }),
            i
        }
    }
    ],
    i.c = o,
    i.p = "dist/",
    i(0);
    function i(t) {
        if (o[t])
            return o[t].exports;
        var e = o[t] = {
            exports: {},
            id: t,
            loaded: !1
        };
        return n[t].call(e.exports, e, e.exports, i),
        e.loaded = !0,
        e.exports
    }
    var n, o
}),
function(t) {
    var e, i, n = !1;
    "function" == typeof define && define.amd && (define(t),
    n = !0),
    "object" == typeof exports && (module.exports = t(),
    n = !0),
    n || (e = window.Cookies,
    (i = window.Cookies = t()).noConflict = function() {
        return window.Cookies = e,
        i
    }
    )
}(function() {
    function m() {
        for (var t = 0, e = {}; t < arguments.length; t++) {
            var i, n = arguments[t];
            for (i in n)
                e[i] = n[i]
        }
        return e
    }
    return function t(p) {
        function f(t, e, i) {
            var n, o;
            if ("undefined" != typeof document) {
                if (1 < arguments.length) {
                    "number" == typeof (i = m({
                        path: "/"
                    }, f.defaults, i)).expires && ((o = new Date).setMilliseconds(o.getMilliseconds() + 864e5 * i.expires),
                    i.expires = o),
                    i.expires = i.expires ? i.expires.toUTCString() : "";
                    try {
                        n = JSON.stringify(e),
                        /^[\{\[]/.test(n) && (e = n)
                    } catch (t) {}
                    e = p.write ? p.write(e, t) : encodeURIComponent(String(e)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent),
                    t = (t = (t = encodeURIComponent(String(t))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
                    var r, s = "";
                    for (r in i)
                        i[r] && (s += "; " + r,
                        !0 !== i[r] && (s += "=" + i[r]));
                    return document.cookie = t + "=" + e + s
                }
                t || (n = {});
                for (var a = document.cookie ? document.cookie.split("; ") : [], l = /(%[0-9A-Z]{2})+/g, c = 0; c < a.length; c++) {
                    var u = a[c].split("=")
                      , d = u.slice(1).join("=");
                    this.json || '"' !== d.charAt(0) || (d = d.slice(1, -1));
                    try {
                        var h = u[0].replace(l, decodeURIComponent)
                          , d = p.read ? p.read(d, h) : p(d, h) || d.replace(l, decodeURIComponent);
                        if (this.json)
                            try {
                                d = JSON.parse(d)
                            } catch (t) {}
                        if (t === h) {
                            n = d;
                            break
                        }
                        t || (n[h] = d)
                    } catch (t) {}
                }
                return n
            }
        }
        return (f.set = f).get = function(t) {
            return f.call(f, t)
        }
        ,
        f.getJSON = function() {
            return f.apply({
                json: !0
            }, [].slice.call(arguments))
        }
        ,
        f.defaults = {},
        f.remove = function(t, e) {
            f(t, "", m(e, {
                expires: -1
            }))
        }
        ,
        f.withConverter = t,
        f
    }(function() {})
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? module.exports = e() : t.EvEmitter = e()
}("undefined" != typeof window ? window : this, function() {
    function t() {}
    var e = t.prototype;
    return e.on = function(t, e) {
        if (t && e) {
            var i = this._events = this._events || {}
              , t = i[t] = i[t] || [];
            return -1 == t.indexOf(e) && t.push(e),
            this
        }
    }
    ,
    e.once = function(t, e) {
        if (t && e) {
            this.on(t, e);
            var i = this._onceEvents = this._onceEvents || {};
            return (i[t] = i[t] || {})[e] = !0,
            this
        }
    }
    ,
    e.off = function(t, e) {
        t = this._events && this._events[t];
        if (t && t.length) {
            e = t.indexOf(e);
            return -1 != e && t.splice(e, 1),
            this
        }
    }
    ,
    e.emitEvent = function(t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
            i = i.slice(0),
            e = e || [];
            for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                var r = i[o];
                n && n[r] && (this.off(t, r),
                delete n[r]),
                r.apply(this, e)
            }
            return this
        }
    }
    ,
    e.allOff = function() {
        delete this._events,
        delete this._onceEvents
    }
    ,
    t
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? module.exports = e() : t.getSize = e()
}(window, function() {
    "use strict";
    function p(t) {
        var e = parseFloat(t);
        return -1 == t.indexOf("%") && !isNaN(e) && e
    }
    var f = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"]
      , m = f.length;
    function g(t) {
        return getComputedStyle(t)
    }
    var v, y = !1;
    function b(t) {
        if (y || (y = !0,
        (h = document.createElement("div")).style.width = "200px",
        h.style.padding = "1px 2px 3px 4px",
        h.style.borderStyle = "solid",
        h.style.borderWidth = "1px 2px 3px 4px",
        h.style.boxSizing = "border-box",
        (d = document.body || document.documentElement).appendChild(h),
        u = g(h),
        v = 200 == Math.round(p(u.width)),
        b.isBoxSizeOuter = v,
        d.removeChild(h)),
        "string" == typeof t && (t = document.querySelector(t)),
        t && "object" == typeof t && t.nodeType) {
            var e = g(t);
            if ("none" == e.display)
                return function() {
                    for (var t = {
                        width: 0,
                        height: 0,
                        innerWidth: 0,
                        innerHeight: 0,
                        outerWidth: 0,
                        outerHeight: 0
                    }, e = 0; e < m; e++)
                        t[f[e]] = 0;
                    return t
                }();
            var i = {};
            i.width = t.offsetWidth,
            i.height = t.offsetHeight;
            for (var n = i.isBorderBox = "border-box" == e.boxSizing, o = 0; o < m; o++) {
                var r = f[o]
                  , s = e[r]
                  , s = parseFloat(s);
                i[r] = isNaN(s) ? 0 : s
            }
            var a = i.paddingLeft + i.paddingRight
              , l = i.paddingTop + i.paddingBottom
              , c = i.marginLeft + i.marginRight
              , u = i.marginTop + i.marginBottom
              , d = i.borderLeftWidth + i.borderRightWidth
              , h = i.borderTopWidth + i.borderBottomWidth
              , t = n && v
              , n = p(e.width);
            !1 !== n && (i.width = n + (t ? 0 : a + d));
            n = p(e.height);
            return !1 !== n && (i.height = n + (t ? 0 : l + h)),
            i.innerWidth = i.width - (a + d),
            i.innerHeight = i.height - (l + h),
            i.outerWidth = i.width + c,
            i.outerHeight = i.height + u,
            i
        }
        var h, d, u
    }
    return b
}),
function(t, e) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? module.exports = e() : t.matchesSelector = e()
}(window, function() {
    "use strict";
    var i = function() {
        var t = window.Element.prototype;
        if (t.matches)
            return "matches";
        if (t.matchesSelector)
            return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
            var n = e[i] + "MatchesSelector";
            if (t[n])
                return n
        }
    }();
    return function(t, e) {
        return t[i](e)
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function(t) {
        return e(0, t)
    }) : "object" == typeof module && module.exports ? module.exports = e(0, require("desandro-matches-selector")) : t.fizzyUIUtils = e(0, t.matchesSelector)
}(window, function(t, r) {
    var s = {
        extend: function(t, e) {
            for (var i in e)
                t[i] = e[i];
            return t
        },
        modulo: function(t, e) {
            return (t % e + e) % e
        }
    }
      , e = Array.prototype.slice;
    return s.makeArray = function(t) {
        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? e.call(t) : [t]
    }
    ,
    s.removeFrom = function(t, e) {
        e = t.indexOf(e);
        -1 != e && t.splice(e, 1)
    }
    ,
    s.getParent = function(t, e) {
        for (; t.parentNode && t != document.body; )
            if (t = t.parentNode,
            r(t, e))
                return t
    }
    ,
    s.getQueryElement = function(t) {
        return "string" == typeof t ? document.querySelector(t) : t
    }
    ,
    s.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    s.filterFindElements = function(t, n) {
        t = s.makeArray(t);
        var o = [];
        return t.forEach(function(t) {
            if (t instanceof HTMLElement)
                if (n) {
                    r(t, n) && o.push(t);
                    for (var e = t.querySelectorAll(n), i = 0; i < e.length; i++)
                        o.push(e[i])
                } else
                    o.push(t)
        }),
        o
    }
    ,
    s.debounceMethod = function(t, e, n) {
        n = n || 100;
        var o = t.prototype[e]
          , r = e + "Timeout";
        t.prototype[e] = function() {
            var t = this[r];
            clearTimeout(t);
            var e = arguments
              , i = this;
            this[r] = setTimeout(function() {
                o.apply(i, e),
                delete i[r]
            }, n)
        }
    }
    ,
    s.docReady = function(t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
    }
    ,
    s.toDashed = function(t) {
        return t.replace(/(.)([A-Z])/g, function(t, e, i) {
            return e + "-" + i
        }).toLowerCase()
    }
    ,
    s.htmlInit = function(r, i) {
        s.docReady(function() {
            var t = s.toDashed(i)
              , n = "data-" + t
              , e = document.querySelectorAll("[" + n + "]")
              , t = document.querySelectorAll(".js-" + t)
              , t = s.makeArray(e).concat(s.makeArray(t))
              , o = n + "-options";
            t.forEach(function(t) {
                var e, i = t.getAttribute(n) || t.getAttribute(o);
                try {
                    e = i && JSON.parse(i)
                } catch (t) {
                    return
                }
                new r(t,e)
            })
        })
    }
    ,
    s
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/cell", ["get-size/get-size"], function(t) {
        return e(0, t)
    }) : "object" == typeof module && module.exports ? module.exports = e(0, require("get-size")) : (t.Flickity = t.Flickity || {},
    t.Flickity.Cell = e(0, t.getSize))
}(window, function(t, e) {
    function i(t, e) {
        this.element = t,
        this.parent = e,
        this.create()
    }
    var n = i.prototype;
    return n.create = function() {
        this.element.style.position = "absolute",
        this.element.setAttribute("aria-hidden", "true"),
        this.x = 0,
        this.shift = 0,
        this.element.style[this.parent.originSide] = 0
    }
    ,
    n.destroy = function() {
        this.unselect(),
        this.element.style.position = "";
        var t = this.parent.originSide;
        this.element.style[t] = "",
        this.element.style.transform = "",
        this.element.removeAttribute("aria-hidden")
    }
    ,
    n.getSize = function() {
        this.size = e(this.element)
    }
    ,
    n.setPosition = function(t) {
        this.x = t,
        this.updateTarget(),
        this.renderPosition(t)
    }
    ,
    n.updateTarget = n.setDefaultTarget = function() {
        var t = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign
    }
    ,
    n.renderPosition = function(t) {
        var e = "left" === this.parent.originSide ? 1 : -1
          , e = this.parent.options.percentPosition ? t * e * (this.parent.size.innerWidth / this.size.width) : t * e;
        this.element.style.transform = "translateX(" + this.parent.getPositionValue(e) + ")"
    }
    ,
    n.select = function() {
        this.element.classList.add("is-selected"),
        this.element.removeAttribute("aria-hidden")
    }
    ,
    n.unselect = function() {
        this.element.classList.remove("is-selected"),
        this.element.setAttribute("aria-hidden", "true")
    }
    ,
    n.wrapShift = function(t) {
        this.shift = t,
        this.renderPosition(this.x + this.parent.slideableWidth * t)
    }
    ,
    n.remove = function() {
        this.element.parentNode.removeChild(this.element)
    }
    ,
    i
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/slide", e) : "object" == typeof module && module.exports ? module.exports = e() : (t.Flickity = t.Flickity || {},
    t.Flickity.Slide = e())
}(window, function() {
    "use strict";
    function t(t) {
        this.parent = t,
        this.isOriginLeft = "left" == t.originSide,
        this.cells = [],
        this.outerWidth = 0,
        this.height = 0
    }
    var e = t.prototype;
    return e.addCell = function(t) {
        var e;
        this.cells.push(t),
        this.outerWidth += t.size.outerWidth,
        this.height = Math.max(t.size.outerHeight, this.height),
        1 == this.cells.length && (this.x = t.x,
        e = this.isOriginLeft ? "marginLeft" : "marginRight",
        this.firstMargin = t.size[e])
    }
    ,
    e.updateTarget = function() {
        var t = this.isOriginLeft ? "marginRight" : "marginLeft"
          , e = this.getLastCell()
          , t = e ? e.size[t] : 0
          , t = this.outerWidth - (this.firstMargin + t);
        this.target = this.x + this.firstMargin + t * this.parent.cellAlign
    }
    ,
    e.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }
    ,
    e.select = function() {
        this.cells.forEach(function(t) {
            t.select()
        })
    }
    ,
    e.unselect = function() {
        this.cells.forEach(function(t) {
            t.unselect()
        })
    }
    ,
    e.getCellElements = function() {
        return this.cells.map(function(t) {
            return t.element
        })
    }
    ,
    t
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function(t) {
        return e(0, t)
    }) : "object" == typeof module && module.exports ? module.exports = e(0, require("fizzy-ui-utils")) : (t.Flickity = t.Flickity || {},
    t.Flickity.animatePrototype = e(0, t.fizzyUIUtils))
}(window, function(t, e) {
    return {
        startAnimation: function() {
            this.isAnimating || (this.isAnimating = !0,
            this.restingFrames = 0,
            this.animate())
        },
        animate: function() {
            this.applyDragForce(),
            this.applySelectedAttraction();
            var t, e = this.x;
            this.integratePhysics(),
            this.positionSlider(),
            this.settle(e),
            this.isAnimating && (t = this,
            requestAnimationFrame(function() {
                t.animate()
            }))
        },
        positionSlider: function() {
            var t = this.x;
            this.options.wrapAround && 1 < this.cells.length && (t = e.modulo(t, this.slideableWidth),
            t -= this.slideableWidth,
            this.shiftWrapCells(t)),
            this.setTranslateX(t, this.isAnimating),
            this.dispatchScrollEvent()
        },
        setTranslateX: function(t, e) {
            t += this.cursorPosition,
            t = this.options.rightToLeft ? -t : t;
            t = this.getPositionValue(t);
            this.slider.style.transform = e ? "translate3d(" + t + ",0,0)" : "translateX(" + t + ")"
        },
        dispatchScrollEvent: function() {
            var t, e = this.slides[0];
            e && (e = (t = -this.x - e.target) / this.slidesWidth,
            this.dispatchEvent("scroll", null, [e, t]))
        },
        positionSliderAtSelected: function() {
            this.cells.length && (this.x = -this.selectedSlide.target,
            this.velocity = 0,
            this.positionSlider())
        },
        getPositionValue: function(t) {
            return this.options.percentPosition ? .01 * Math.round(t / this.size.innerWidth * 1e4) + "%" : Math.round(t) + "px"
        },
        settle: function(t) {
            this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * t) || this.restingFrames++,
            2 < this.restingFrames && (this.isAnimating = !1,
            delete this.isFreeScrolling,
            this.positionSlider(),
            this.dispatchEvent("settle", null, [this.selectedIndex]))
        },
        shiftWrapCells: function(t) {
            var e = this.cursorPosition + t;
            this._shiftCells(this.beforeShiftCells, e, -1);
            t = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
            this._shiftCells(this.afterShiftCells, t, 1)
        },
        _shiftCells: function(t, e, i) {
            for (var n = 0; n < t.length; n++) {
                var o = t[n]
                  , r = 0 < e ? i : 0;
                o.wrapShift(r),
                e -= o.size.outerWidth
            }
        },
        _unshiftCells: function(t) {
            if (t && t.length)
                for (var e = 0; e < t.length; e++)
                    t[e].wrapShift(0)
        },
        integratePhysics: function() {
            this.x += this.velocity,
            this.velocity *= this.getFrictionFactor()
        },
        applyForce: function(t) {
            this.velocity += t
        },
        getFrictionFactor: function() {
            return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        },
        getRestingPosition: function() {
            return this.x + this.velocity / (1 - this.getFrictionFactor())
        },
        applyDragForce: function() {
            var t;
            this.isDraggable && this.isPointerDown && (t = this.dragX - this.x - this.velocity,
            this.applyForce(t))
        },
        applySelectedAttraction: function() {
            var t;
            this.isDraggable && this.isPointerDown || this.isFreeScrolling || !this.slides.length || (t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction,
            this.applyForce(t))
        }
    }
}),
function(s, a) {
    var t;
    "function" == typeof define && define.amd ? define("flickity/js/flickity", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function(t, e, i, n, o, r) {
        return a(s, t, e, i, n, o, r)
    }) : "object" == typeof module && module.exports ? module.exports = a(s, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate")) : (t = s.Flickity,
    s.Flickity = a(s, s.EvEmitter, s.getSize, s.fizzyUIUtils, t.Cell, t.Slide, t.animatePrototype))
}(window, function(e, t, i, s, n, a, o) {
    function r(t, e) {
        for (t = s.makeArray(t); t.length; )
            e.appendChild(t.shift())
    }
    e.getComputedStyle;
    var l = 0
      , c = {};
    function u(t, e) {
        t = s.getQueryElement(t);
        if (t) {
            if (this.element = t,
            this.element.flickityGUID) {
                t = c[this.element.flickityGUID];
                return t && t.option(e),
                t
            }
            this.options = s.extend({}, this.constructor.defaults),
            this.option(e),
            this._create()
        }
    }
    u.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        initialIndex: 0,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0,
        wrapAround: !1
    },
    u.createMethods = [];
    var d = u.prototype;
    s.extend(d, t.prototype),
    d._create = function() {
        var t, e = this.guid = ++l;
        for (t in this.element.flickityGUID = e,
        (c[e] = this).selectedIndex = 0,
        this.restingFrames = 0,
        this.x = 0,
        this.velocity = 0,
        this.originSide = this.options.rightToLeft ? "right" : "left",
        this.viewport = document.createElement("div"),
        this.viewport.className = "flickity-viewport",
        this._createSlider(),
        this.options.on) {
            var i = this.options.on[t];
            this.on(t, i)
        }
        u.createMethods.forEach(function(t) {
            this[t]()
        }, this),
        this.activate()
    }
    ,
    d.option = function(t) {
        s.extend(this.options, t)
    }
    ,
    d.activate = function() {
        this.isActive || (this.isActive = !0,
        this.element.classList.add("flickity-enabled"),
        this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
        this.getSize(),
        r(this._filterFindCellElements(this.element.children), this.slider),
        this.viewport.appendChild(this.slider),
        this.element.appendChild(this.viewport),
        this.reloadCells(),
        this.options.accessibility && (this.element.tabIndex = 0,
        this.element.addEventListener("keydown", this)),
        this.emitEvent("activate"),
        this.selectInitialIndex(),
        this.isInitActivated = !0,
        this.dispatchEvent("ready", null, [this.element]))
    }
    ,
    d._createSlider = function() {
        var t = document.createElement("div");
        t.className = "flickity-slider",
        t.style[this.originSide] = 0,
        this.slider = t
    }
    ,
    d._filterFindCellElements = function(t) {
        return s.filterFindElements(t, this.options.cellSelector)
    }
    ,
    d.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children),
        this.positionCells(),
        this._getWrapShiftCells(),
        this.setGallerySize()
    }
    ,
    d._makeCells = function(t) {
        return this._filterFindCellElements(t).map(function(t) {
            return new n(t,this)
        }, this)
    }
    ,
    d.getLastCell = function() {
        return this.cells[this.cells.length - 1]
    }
    ,
    d.getLastSlide = function() {
        return this.slides[this.slides.length - 1]
    }
    ,
    d.positionCells = function() {
        this._sizeCells(this.cells),
        this._positionCells(0)
    }
    ,
    d._positionCells = function(t) {
        t = t || 0,
        this.maxCellHeight = t && this.maxCellHeight || 0;
        var e, i = 0;
        0 < t && (i = (e = this.cells[t - 1]).x + e.size.outerWidth);
        for (var n = this.cells.length, o = t; o < n; o++) {
            var r = this.cells[o];
            r.setPosition(i),
            i += r.size.outerWidth,
            this.maxCellHeight = Math.max(r.size.outerHeight, this.maxCellHeight)
        }
        this.slideableWidth = i,
        this.updateSlides(),
        this._containSlides(),
        this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0
    }
    ,
    d._sizeCells = function(t) {
        t.forEach(function(t) {
            t.getSize()
        })
    }
    ,
    d.updateSlides = function() {
        var n, o, r;
        this.slides = [],
        this.cells.length && (n = new a(this),
        this.slides.push(n),
        o = "left" == this.originSide ? "marginRight" : "marginLeft",
        r = this._getCanCellFit(),
        this.cells.forEach(function(t, e) {
            var i;
            n.cells.length && (i = n.outerWidth - n.firstMargin + (t.size.outerWidth - t.size[o]),
            r.call(this, e, i) || (n.updateTarget(),
            n = new a(this),
            this.slides.push(n))),
            n.addCell(t)
        }, this),
        n.updateTarget(),
        this.updateSelectedSlide())
    }
    ,
    d._getCanCellFit = function() {
        var t = this.options.groupCells;
        if (!t)
            return function() {
                return !1
            }
            ;
        if ("number" == typeof t) {
            var e = parseInt(t, 10);
            return function(t) {
                return t % e != 0
            }
        }
        var t = "string" == typeof t && t.match(/^(\d+)%$/)
          , i = t ? parseInt(t[1], 10) / 100 : 1;
        return function(t, e) {
            return e <= (this.size.innerWidth + 1) * i
        }
    }
    ,
    d.reposition = function() {
        this.positionCells(),
        this.positionSliderAtSelected()
    }
    ,
    d.getSize = function() {
        this.size = i(this.element),
        this.setCellAlign(),
        this.cursorPosition = this.size.innerWidth * this.cellAlign
    }
    ;
    var h = {
        center: {
            left: .5,
            right: .5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    return d.setCellAlign = function() {
        var t = h[this.options.cellAlign];
        this.cellAlign = t ? t[this.originSide] : this.options.cellAlign
    }
    ,
    d.setGallerySize = function() {
        var t;
        this.options.setGallerySize && (t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight,
        this.viewport.style.height = t + "px")
    }
    ,
    d._getWrapShiftCells = function() {
        var t, e;
        this.options.wrapAround && (this._unshiftCells(this.beforeShiftCells),
        this._unshiftCells(this.afterShiftCells),
        t = this.cursorPosition,
        e = this.cells.length - 1,
        this.beforeShiftCells = this._getGapCells(t, e, -1),
        t = this.size.innerWidth - this.cursorPosition,
        this.afterShiftCells = this._getGapCells(t, 0, 1))
    }
    ,
    d._getGapCells = function(t, e, i) {
        for (var n = []; 0 < t; ) {
            var o = this.cells[e];
            if (!o)
                break;
            n.push(o),
            e += i,
            t -= o.size.outerWidth
        }
        return n
    }
    ,
    d._containSlides = function() {
        var t, e, i, n, o, r;
        this.options.contain && !this.options.wrapAround && this.cells.length && (t = (e = this.options.rightToLeft) ? "marginRight" : "marginLeft",
        e = e ? "marginLeft" : "marginRight",
        i = this.slideableWidth - this.getLastCell().size[e],
        n = i < this.size.innerWidth,
        o = this.cursorPosition + this.cells[0].size[t],
        r = i - this.size.innerWidth * (1 - this.cellAlign),
        this.slides.forEach(function(t) {
            n ? t.target = i * this.cellAlign : (t.target = Math.max(t.target, o),
            t.target = Math.min(t.target, r))
        }, this))
    }
    ,
    d.dispatchEvent = function(t, e, i) {
        i = e ? [e].concat(i) : i;
        this.emitEvent(t, i)
    }
    ,
    d.select = function(t, e, i) {
        this.isActive && (t = parseInt(t, 10),
        this._wrapSelect(t),
        (this.options.wrapAround || e) && (t = s.modulo(t, this.slides.length)),
        this.slides[t]) && (e = this.selectedIndex,
        this.selectedIndex = t,
        this.updateSelectedSlide(),
        i ? this.positionSliderAtSelected() : this.startAnimation(),
        this.options.adaptiveHeight && this.setGallerySize(),
        this.dispatchEvent("select", null, [t]),
        t != e && this.dispatchEvent("change", null, [t]),
        this.dispatchEvent("cellSelect"))
    }
    ,
    d._wrapSelect = function(t) {
        var e = this.slides.length;
        if (!(this.options.wrapAround && 1 < e))
            return t;
        var i = s.modulo(t, e)
          , n = Math.abs(i - this.selectedIndex)
          , o = Math.abs(i + e - this.selectedIndex)
          , i = Math.abs(i - e - this.selectedIndex);
        !this.isDragSelect && o < n ? t += e : !this.isDragSelect && i < n && (t -= e),
        t < 0 ? this.x -= this.slideableWidth : e <= t && (this.x += this.slideableWidth)
    }
    ,
    d.previous = function(t, e) {
        this.select(this.selectedIndex - 1, t, e)
    }
    ,
    d.next = function(t, e) {
        this.select(this.selectedIndex + 1, t, e)
    }
    ,
    d.updateSelectedSlide = function() {
        var t = this.slides[this.selectedIndex];
        t && (this.unselectSelectedSlide(),
        (this.selectedSlide = t).select(),
        this.selectedCells = t.cells,
        this.selectedElements = t.getCellElements(),
        this.selectedCell = t.cells[0],
        this.selectedElement = this.selectedElements[0])
    }
    ,
    d.unselectSelectedSlide = function() {
        this.selectedSlide && this.selectedSlide.unselect()
    }
    ,
    d.selectInitialIndex = function() {
        var t, e = this.options.initialIndex;
        this.isInitActivated ? this.select(this.selectedIndex, !1, !0) : e && "string" == typeof e && this.queryCell(e) ? this.selectCell(e, !1, !0) : (t = 0,
        e && this.slides[e] && (t = e),
        this.select(t, !1, !0))
    }
    ,
    d.selectCell = function(t, e, i) {
        t = this.queryCell(t);
        t && (t = this.getCellSlideIndex(t),
        this.select(t, e, i))
    }
    ,
    d.getCellSlideIndex = function(t) {
        for (var e = 0; e < this.slides.length; e++)
            if (-1 != this.slides[e].cells.indexOf(t))
                return e
    }
    ,
    d.getCell = function(t) {
        for (var e = 0; e < this.cells.length; e++) {
            var i = this.cells[e];
            if (i.element == t)
                return i
        }
    }
    ,
    d.getCells = function(t) {
        t = s.makeArray(t);
        var e = [];
        return t.forEach(function(t) {
            t = this.getCell(t);
            t && e.push(t)
        }, this),
        e
    }
    ,
    d.getCellElements = function() {
        return this.cells.map(function(t) {
            return t.element
        })
    }
    ,
    d.getParentCell = function(t) {
        return this.getCell(t) || (t = s.getParent(t, ".flickity-slider > *"),
        this.getCell(t))
    }
    ,
    d.getAdjacentCellElements = function(t, e) {
        if (!t)
            return this.selectedSlide.getCellElements();
        e = void 0 === e ? this.selectedIndex : e;
        var i = this.slides.length;
        if (i <= 1 + 2 * t)
            return this.getCellElements();
        for (var n = [], o = e - t; o <= e + t; o++) {
            var r = this.options.wrapAround ? s.modulo(o, i) : o
              , r = this.slides[r];
            r && (n = n.concat(r.getCellElements()))
        }
        return n
    }
    ,
    d.queryCell = function(t) {
        if ("number" == typeof t)
            return this.cells[t];
        if ("string" == typeof t) {
            if (t.match(/^[#.]?[\d/]/))
                return;
            t = this.element.querySelector(t)
        }
        return this.getCell(t)
    }
    ,
    d.uiChange = function() {
        this.emitEvent("uiChange")
    }
    ,
    d.childUIPointerDown = function(t) {
        "touchstart" != t.type && t.preventDefault(),
        this.focus()
    }
    ,
    d.onresize = function() {
        this.resize()
    }
    ,
    s.debounceMethod(u, "onresize", 150),
    d.resize = function() {
        var t;
        !this.isActive || this.isAnimating || this.isDragging || (this.getSize(),
        this.options.wrapAround && (this.x = s.modulo(this.x, this.slideableWidth)),
        this.positionCells(),
        this._getWrapShiftCells(),
        this.setGallerySize(),
        this.emitEvent("resize"),
        t = this.selectedElements && this.selectedElements[0],
        this.selectCell(t, !1, !0))
    }
    ,
    d.onkeydown = function(t) {
        var e = document.activeElement && document.activeElement != this.element;
        !this.options.accessibility || e || (t = u.keyboardHandlers[t.keyCode]) && t.call(this)
    }
    ,
    u.keyboardHandlers = {
        37: function() {
            var t = this.options.rightToLeft ? "next" : "previous";
            this.uiChange(),
            this[t]()
        },
        39: function() {
            var t = this.options.rightToLeft ? "previous" : "next";
            this.uiChange(),
            this[t]()
        }
    },
    d.focus = function() {
        var t = e.pageYOffset;
        this.element.focus({
            preventScroll: !0
        }),
        e.pageYOffset != t && e.scrollTo(e.pageXOffset, t)
    }
    ,
    d.deactivate = function() {
        this.isActive && (this.element.classList.remove("flickity-enabled"),
        this.element.classList.remove("flickity-rtl"),
        this.unselectSelectedSlide(),
        this.cells.forEach(function(t) {
            t.destroy()
        }),
        this.element.removeChild(this.viewport),
        r(this.slider.children, this.element),
        this.options.accessibility && (this.element.removeAttribute("tabIndex"),
        this.element.removeEventListener("keydown", this)),
        this.isActive = !1,
        this.emitEvent("deactivate"))
    }
    ,
    d.destroy = function() {
        this.deactivate(),
        e.removeEventListener("resize", this),
        this.allOff(),
        this.emitEvent("destroy"),
        delete this.element.flickityGUID,
        delete c[this.guid]
    }
    ,
    s.extend(d, o),
    u.data = function(t) {
        t = (t = s.getQueryElement(t)) && t.flickityGUID;
        return t && c[t]
    }
    ,
    s.htmlInit(u, "flickity"),
    u.Cell = n,
    u.Slide = a,
    u
}),
function(e, i) {
    "function" == typeof define && define.amd ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function(t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("ev-emitter")) : e.Unipointer = i(e, e.EvEmitter)
}(window, function(n, t) {
    function e() {}
    t = e.prototype = Object.create(t.prototype);
    t.bindStartEvent = function(t) {
        this._bindStartEvent(t, !0)
    }
    ,
    t.unbindStartEvent = function(t) {
        this._bindStartEvent(t, !1)
    }
    ,
        t._bindStartEvent = function(t, e) {
        var i = (e = void 0 === e || e) ? "addEventListener" : "removeEventListener",
            e = "mousedown";
        "ontouchstart" in n ? e = "touchstart" : n.PointerEvent && (e = "pointerdown");
    
        // Add { passive: true } to the event listener options
        var options = { passive: true };
        t[i](e, this, options);
        }
    ,
    t.handleEvent = function(t) {
        var e = "on" + t.type;
        this[e] && this[e](t)
    }
    ,
    t.getTouch = function(t) {
        for (var e = 0; e < t.length; e++) {
            var i = t[e];
            if (i.identifier == this.pointerIdentifier)
                return i
        }
    }
    ,
    t.onmousedown = function(t) {
        var e = t.button;
        e && 0 !== e && 1 !== e || this._pointerDown(t, t)
    }
    ,
    t.ontouchstart = function(t) {
        this._pointerDown(t, t.changedTouches[0])
    }
    ,
    t.onpointerdown = function(t) {
        this._pointerDown(t, t)
    }
    ,
    t._pointerDown = function(t, e) {
        t.button || this.isPointerDown || (this.isPointerDown = !0,
        this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier,
        this.pointerDown(t, e))
    }
    ,
    t.pointerDown = function(t, e) {
        this._bindPostStartEvents(t),
        this.emitEvent("pointerDown", [t, e])
    }
    ;
    var i = {
        mousedown: ["mousemove", "mouseup"],
        touchstart: ["touchmove", "touchend", "touchcancel"],
        pointerdown: ["pointermove", "pointerup", "pointercancel"]
    };
    return t._bindPostStartEvents = function(t) {
        t && ((t = i[t.type]).forEach(function(t) {
            n.addEventListener(t, this)
        }, this),
        this._boundPointerEvents = t)
    }
    ,
    t._unbindPostStartEvents = function() {
        this._boundPointerEvents && (this._boundPointerEvents.forEach(function(t) {
            n.removeEventListener(t, this)
        }, this),
        delete this._boundPointerEvents)
    }
    ,
    t.onmousemove = function(t) {
        this._pointerMove(t, t)
    }
    ,
    t.onpointermove = function(t) {
        t.pointerId == this.pointerIdentifier && this._pointerMove(t, t)
    }
    ,
    t.ontouchmove = function(t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerMove(t, e)
    }
    ,
    t._pointerMove = function(t, e) {
        this.pointerMove(t, e)
    }
    ,
    t.pointerMove = function(t, e) {
        this.emitEvent("pointerMove", [t, e])
    }
    ,
    t.onmouseup = function(t) {
        this._pointerUp(t, t)
    }
    ,
    t.onpointerup = function(t) {
        t.pointerId == this.pointerIdentifier && this._pointerUp(t, t)
    }
    ,
    t.ontouchend = function(t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerUp(t, e)
    }
    ,
    t._pointerUp = function(t, e) {
        this._pointerDone(),
        this.pointerUp(t, e)
    }
    ,
    t.pointerUp = function(t, e) {
        this.emitEvent("pointerUp", [t, e])
    }
    ,
    t._pointerDone = function() {
        this._pointerReset(),
        this._unbindPostStartEvents(),
        this.pointerDone()
    }
    ,
    t._pointerReset = function() {
        this.isPointerDown = !1,
        delete this.pointerIdentifier
    }
    ,
    t.pointerDone = function() {}
    ,
    t.onpointercancel = function(t) {
        t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t)
    }
    ,
    t.ontouchcancel = function(t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerCancel(t, e)
    }
    ,
    t._pointerCancel = function(t, e) {
        this._pointerDone(),
        this.pointerCancel(t, e)
    }
    ,
    t.pointerCancel = function(t, e) {
        this.emitEvent("pointerCancel", [t, e])
    }
    ,
    e.getPointerPoint = function(t) {
        return {
            x: t.pageX,
            y: t.pageY
        }
    }
    ,
    e
}),
function(e, i) {
    "function" == typeof define && define.amd ? define("unidragger/unidragger", ["unipointer/unipointer"], function(t) {
        return i(e, t)
    }) : "object" == typeof module && module.exports ? module.exports = i(e, require("unipointer")) : e.Unidragger = i(e, e.Unipointer)
}(window, function(r, t) {
    function e() {}
    var i = e.prototype = Object.create(t.prototype);
    i.bindHandles = function() {
        this._bindHandles(!0)
    }
    ,
    i.unbindHandles = function() {
        this._bindHandles(!1)
    }
    ,
    i._bindHandles = function(t) {
        for (var e = (t = void 0 === t || t) ? "addEventListener" : "removeEventListener", i = t ? this._touchActionValue : "", n = 0; n < this.handles.length; n++) {
            var o = this.handles[n];
            this._bindStartEvent(o, t),
            o[e]("click", this),
            r.PointerEvent && (o.style.touchAction = i)
        }
    }
    ,
    i._touchActionValue = "none",
    i.pointerDown = function(t, e) {
        this.okayPointerDown(t) && (this.pointerDownPointer = {
            pageX: e.pageX,
            pageY: e.pageY
        },
        t.preventDefault(),
        this.pointerDownBlur(),
        this._bindPostStartEvents(t),
        this.emitEvent("pointerDown", [t, e]))
    }
    ;
    var n = {
        TEXTAREA: !0,
        INPUT: !0,
        SELECT: !0,
        OPTION: !0
    }
      , o = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0
    };
    return i.okayPointerDown = function(t) {
        var e = n[t.target.nodeName]
          , t = o[t.target.type]
          , t = !e || t;
        return t || this._pointerReset(),
        t
    }
    ,
    i.pointerDownBlur = function() {
        var t = document.activeElement;
        t && t.blur && t != document.body && t.blur()
    }
    ,
    i.pointerMove = function(t, e) {
        var i = this._dragPointerMove(t, e);
        this.emitEvent("pointerMove", [t, e, i]),
        this._dragMove(t, e, i)
    }
    ,
    i._dragPointerMove = function(t, e) {
        var i = {
            x: e.pageX - this.pointerDownPointer.pageX,
            y: e.pageY - this.pointerDownPointer.pageY
        };
        return !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e),
        i
    }
    ,
    i.hasDragStarted = function(t) {
        return 3 < Math.abs(t.x) || 3 < Math.abs(t.y)
    }
    ,
    i.pointerUp = function(t, e) {
        this.emitEvent("pointerUp", [t, e]),
        this._dragPointerUp(t, e)
    }
    ,
    i._dragPointerUp = function(t, e) {
        this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e)
    }
    ,
    i._dragStart = function(t, e) {
        this.isDragging = !0,
        this.isPreventingClicks = !0,
        this.dragStart(t, e)
    }
    ,
    i.dragStart = function(t, e) {
        this.emitEvent("dragStart", [t, e])
    }
    ,
    i._dragMove = function(t, e, i) {
        this.isDragging && this.dragMove(t, e, i)
    }
    ,
    i.dragMove = function(t, e, i) {
        t.preventDefault(),
        this.emitEvent("dragMove", [t, e, i])
    }
    ,
    i._dragEnd = function(t, e) {
        this.isDragging = !1,
        setTimeout(function() {
            delete this.isPreventingClicks
        }
        .bind(this)),
        this.dragEnd(t, e)
    }
    ,
    i.dragEnd = function(t, e) {
        this.emitEvent("dragEnd", [t, e])
    }
    ,
    i.onclick = function(t) {
        this.isPreventingClicks && t.preventDefault()
    }
    ,
    i._staticClick = function(t, e) {
        this.isIgnoringMouseUp && "mouseup" == t.type || (this.staticClick(t, e),
        "mouseup" != t.type && (this.isIgnoringMouseUp = !0,
        setTimeout(function() {
            delete this.isIgnoringMouseUp
        }
        .bind(this), 400)))
    }
    ,
    i.staticClick = function(t, e) {
        this.emitEvent("staticClick", [t, e])
    }
    ,
    e.getPointerPoint = t.getPointerPoint,
    e
}),
function(n, o) {
    "function" == typeof define && define.amd ? define("flickity/js/drag", ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"], function(t, e, i) {
        return o(n, t, e, i)
    }) : "object" == typeof module && module.exports ? module.exports = o(n, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : n.Flickity = o(n, n.Flickity, n.Unidragger, n.fizzyUIUtils)
}(window, function(i, t, e, r) {
    r.extend(t.defaults, {
        draggable: ">1",
        dragThreshold: 3
    }),
    t.createMethods.push("_createDrag");
    var n = t.prototype;
    r.extend(n, e.prototype),
    n._touchActionValue = "pan-y",
    n._createDrag = function() {
        this.on("activate", this.onActivateDrag),
        this.on("uiChange", this._uiChangeDrag),
        this.on("deactivate", this.onDeactivateDrag),
        this.on("cellChange", this.updateDraggable)
    }
    ,
    n.onActivateDrag = function() {
        this.handles = [this.viewport],
        this.bindHandles(),
        this.updateDraggable()
    }
    ,
    n.onDeactivateDrag = function() {
        this.unbindHandles(),
        this.element.classList.remove("is-draggable")
    }
    ,
    n.updateDraggable = function() {
        ">1" == this.options.draggable ? this.isDraggable = 1 < this.slides.length : this.isDraggable = this.options.draggable,
        this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
    }
    ,
    n.bindDrag = function() {
        this.options.draggable = !0,
        this.updateDraggable()
    }
    ,
    n.unbindDrag = function() {
        this.options.draggable = !1,
        this.updateDraggable()
    }
    ,
    n._uiChangeDrag = function() {
        delete this.isFreeScrolling
    }
    ,
    n.pointerDown = function(t, e) {
        this.isDraggable ? this.okayPointerDown(t) && (this._pointerDownPreventDefault(t),
        this.pointerDownFocus(t),
        document.activeElement != this.element && this.pointerDownBlur(),
        this.dragX = this.x,
        this.viewport.classList.add("is-pointer-down"),
        this.pointerDownScroll = s(),
        i.addEventListener("scroll", this),
        this._pointerDownDefault(t, e)) : this._pointerDownDefault(t, e)
    }
    ,
    n._pointerDownDefault = function(t, e) {
        this.pointerDownPointer = {
            pageX: e.pageX,
            pageY: e.pageY
        },
        this._bindPostStartEvents(t),
        this.dispatchEvent("pointerDown", t, [e])
    }
    ;
    var o = {
        INPUT: !0,
        TEXTAREA: !0,
        SELECT: !0
    };
    function s() {
        return {
            x: i.pageXOffset,
            y: i.pageYOffset
        }
    }
    return n.pointerDownFocus = function(t) {
        o[t.target.nodeName] || this.focus()
    }
    ,
    n._pointerDownPreventDefault = function(t) {
        var e = "touchstart" == t.type
          , i = "touch" == t.pointerType
          , n = o[t.target.nodeName];
        e || i || n || t.preventDefault()
    }
    ,
    n.hasDragStarted = function(t) {
        return Math.abs(t.x) > this.options.dragThreshold
    }
    ,
    n.pointerUp = function(t, e) {
        delete this.isTouchScrolling,
        this.viewport.classList.remove("is-pointer-down"),
        this.dispatchEvent("pointerUp", t, [e]),
        this._dragPointerUp(t, e)
    }
    ,
    n.pointerDone = function() {
        i.removeEventListener("scroll", this),
        delete this.pointerDownScroll
    }
    ,
    n.dragStart = function(t, e) {
        this.isDraggable && (this.dragStartPosition = this.x,
        this.startAnimation(),
        i.removeEventListener("scroll", this),
        this.dispatchEvent("dragStart", t, [e]))
    }
    ,
    n.pointerMove = function(t, e) {
        var i = this._dragPointerMove(t, e);
        this.dispatchEvent("pointerMove", t, [e, i]),
        this._dragMove(t, e, i)
    }
    ,
    n.dragMove = function(t, e, i) {
        var n, o;
        this.isDraggable && (t.preventDefault(),
        this.previousDragX = this.dragX,
        o = this.options.rightToLeft ? -1 : 1,
        this.options.wrapAround && (i.x %= this.slideableWidth),
        n = this.dragStartPosition + i.x * o,
        !this.options.wrapAround && this.slides.length && (n = (n = (o = Math.max(-this.slides[0].target, this.dragStartPosition)) < n ? .5 * (n + o) : n) < (o = Math.min(-this.getLastSlide().target, this.dragStartPosition)) ? .5 * (n + o) : n),
        this.dragX = n,
        this.dragMoveTime = new Date,
        this.dispatchEvent("dragMove", t, [e, i]))
    }
    ,
    n.dragEnd = function(t, e) {
        var i, n;
        this.isDraggable && (this.options.freeScroll && (this.isFreeScrolling = !0),
        i = this.dragEndRestingSelect(),
        this.options.freeScroll && !this.options.wrapAround ? (n = this.getRestingPosition(),
        this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target) : this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect()),
        delete this.previousDragX,
        this.isDragSelect = this.options.wrapAround,
        this.select(i),
        delete this.isDragSelect,
        this.dispatchEvent("dragEnd", t, [e]))
    }
    ,
    n.dragEndRestingSelect = function() {
        var t = this.getRestingPosition()
          , e = Math.abs(this.getSlideDistance(-t, this.selectedIndex))
          , i = this._getClosestResting(t, e, 1)
          , e = this._getClosestResting(t, e, -1);
        return (i.distance < e.distance ? i : e).index
    }
    ,
    n._getClosestResting = function(t, e, i) {
        for (var n = this.selectedIndex, o = 1 / 0, r = this.options.contain && !this.options.wrapAround ? function(t, e) {
            return t <= e
        }
        : function(t, e) {
            return t < e
        }
        ; r(e, o) && (n += i,
        o = e,
        null !== (e = this.getSlideDistance(-t, n))); )
            e = Math.abs(e);
        return {
            distance: o,
            index: n - i
        }
    }
    ,
    n.getSlideDistance = function(t, e) {
        var i = this.slides.length
          , n = this.options.wrapAround && 1 < i
          , o = n ? r.modulo(e, i) : e
          , o = this.slides[o];
        if (!o)
            return null;
        i = n ? this.slideableWidth * Math.floor(e / i) : 0;
        return t - (o.target + i)
    }
    ,
    n.dragEndBoostSelect = function() {
        if (void 0 === this.previousDragX || !this.dragMoveTime || 100 < new Date - this.dragMoveTime)
            return 0;
        var t = this.getSlideDistance(-this.dragX, this.selectedIndex)
          , e = this.previousDragX - this.dragX;
        return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0
    }
    ,
    n.staticClick = function(t, e) {
        var i = this.getParentCell(t.target)
          , n = i && i.element
          , i = i && this.cells.indexOf(i);
        this.dispatchEvent("staticClick", t, [e, n, i])
    }
    ,
    n.onscroll = function() {
        var t = s()
          , e = this.pointerDownScroll.x - t.x
          , t = this.pointerDownScroll.y - t.y;
        (3 < Math.abs(e) || 3 < Math.abs(t)) && this._pointerDone()
    }
    ,
    t
}),
function(t, n) {
    "function" == typeof define && define.amd ? define("flickity/js/prev-next-button", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function(t, e, i) {
        return n(0, t, e, i)
    }) : "object" == typeof module && module.exports ? module.exports = n(0, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : n(0, t.Flickity, t.Unipointer, t.fizzyUIUtils)
}(window, function(t, e, i, n) {
    "use strict";
    var o = "http://www.w3.org/2000/svg";
    function r(t, e) {
        this.direction = t,
        this.parent = e,
        this._create()
    }
    (r.prototype = Object.create(i.prototype))._create = function() {
        this.isEnabled = !0,
        this.isPrevious = -1 == this.direction;
        var t = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == t;
        var e = this.element = document.createElement("button");
        e.className = "flickity-button flickity-prev-next-button",
        e.className += this.isPrevious ? " flickity-previous" : " flickity-next",
        e.setAttribute("type", "button"),
        this.disable(),
        e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        t = this.createSVG();
        e.appendChild(t),
        this.parent.on("select", this.update.bind(this)),
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }
    ,
    r.prototype.activate = function() {
        this.bindStartEvent(this.element),
        this.element.addEventListener("click", this),
        this.parent.element.appendChild(this.element)
    }
    ,
    r.prototype.deactivate = function() {
        this.parent.element.removeChild(this.element),
        this.unbindStartEvent(this.element),
        this.element.removeEventListener("click", this)
    }
    ,
    r.prototype.createSVG = function() {
        var t = document.createElementNS(o, "svg");
        t.setAttribute("class", "flickity-button-icon"),
        t.setAttribute("viewBox", "0 0 100 100");
        var e, i = document.createElementNS(o, "path"), e = "string" == typeof (e = this.parent.options.arrowShape) ? e : "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z";
        return i.setAttribute("d", e),
        i.setAttribute("class", "arrow"),
        this.isLeft || i.setAttribute("transform", "translate(100, 100) rotate(180) "),
        t.appendChild(i),
        t
    }
    ,
    r.prototype.handleEvent = n.handleEvent,
    r.prototype.onclick = function() {
        var t;
        this.isEnabled && (this.parent.uiChange(),
        t = this.isPrevious ? "previous" : "next",
        this.parent[t]())
    }
    ,
    r.prototype.enable = function() {
        this.isEnabled || (this.element.disabled = !1,
        this.isEnabled = !0)
    }
    ,
    r.prototype.disable = function() {
        this.isEnabled && (this.element.disabled = !0,
        this.isEnabled = !1)
    }
    ,
    r.prototype.update = function() {
        var t = this.parent.slides;
        this.parent.options.wrapAround && 1 < t.length ? this.enable() : (t = t.length ? t.length - 1 : 0,
        t = this.isPrevious ? 0 : t,
        this[this.parent.selectedIndex == t ? "disable" : "enable"]())
    }
    ,
    r.prototype.destroy = function() {
        this.deactivate(),
        this.allOff()
    }
    ,
    n.extend(e.defaults, {
        prevNextButtons: !0,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    }),
    e.createMethods.push("_createPrevNextButtons");
    n = e.prototype;
    return n._createPrevNextButtons = function() {
        this.options.prevNextButtons && (this.prevButton = new r(-1,this),
        this.nextButton = new r(1,this),
        this.on("activate", this.activatePrevNextButtons))
    }
    ,
    n.activatePrevNextButtons = function() {
        this.prevButton.activate(),
        this.nextButton.activate(),
        this.on("deactivate", this.deactivatePrevNextButtons)
    }
    ,
    n.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate(),
        this.nextButton.deactivate(),
        this.off("deactivate", this.deactivatePrevNextButtons)
    }
    ,
    e.PrevNextButton = r,
    e
}),
function(t, n) {
    "function" == typeof define && define.amd ? define("flickity/js/page-dots", ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"], function(t, e, i) {
        return n(0, t, e, i)
    }) : "object" == typeof module && module.exports ? module.exports = n(0, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : n(0, t.Flickity, t.Unipointer, t.fizzyUIUtils)
}(window, function(t, e, i, n) {
    function o(t) {
        this.parent = t,
        this._create()
    }
    (o.prototype = Object.create(i.prototype))._create = function() {
        this.holder = document.createElement("ol"),
        this.holder.className = "flickity-page-dots",
        this.dots = [],
        this.handleClick = this.onClick.bind(this),
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
    }
    ,
    o.prototype.activate = function() {
        this.setDots(),
        this.holder.addEventListener("click", this.handleClick),
        this.bindStartEvent(this.holder),
        this.parent.element.appendChild(this.holder)
    }
    ,
    o.prototype.deactivate = function() {
        this.holder.removeEventListener("click", this.handleClick),
        this.unbindStartEvent(this.holder),
        this.parent.element.removeChild(this.holder)
    }
    ,
    o.prototype.setDots = function() {
        var t = this.parent.slides.length - this.dots.length;
        0 < t ? this.addDots(t) : t < 0 && this.removeDots(-t)
    }
    ,
    o.prototype.addDots = function(t) {
        for (var e = document.createDocumentFragment(), i = [], n = this.dots.length, o = n + t, r = n; r < o; r++) {
            var s = document.createElement("li");
            s.className = "dot",
            s.setAttribute("aria-label", "Page dot " + (r + 1)),
            e.appendChild(s),
            i.push(s)
        }
        this.holder.appendChild(e),
        this.dots = this.dots.concat(i)
    }
    ,
    o.prototype.removeDots = function(t) {
        this.dots.splice(this.dots.length - t, t).forEach(function(t) {
            this.holder.removeChild(t)
        }, this)
    }
    ,
    o.prototype.updateSelected = function() {
        this.selectedDot && (this.selectedDot.className = "dot",
        this.selectedDot.removeAttribute("aria-current")),
        this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex],
        this.selectedDot.className = "dot is-selected",
        this.selectedDot.setAttribute("aria-current", "step"))
    }
    ,
    o.prototype.onTap = o.prototype.onClick = function(t) {
        t = t.target;
        "LI" == t.nodeName && (this.parent.uiChange(),
        t = this.dots.indexOf(t),
        this.parent.select(t))
    }
    ,
    o.prototype.destroy = function() {
        this.deactivate(),
        this.allOff()
    }
    ,
    e.PageDots = o,
    n.extend(e.defaults, {
        pageDots: !0
    }),
    e.createMethods.push("_createPageDots");
    n = e.prototype;
    return n._createPageDots = function() {
        this.options.pageDots && (this.pageDots = new o(this),
        this.on("activate", this.activatePageDots),
        this.on("select", this.updateSelectedPageDots),
        this.on("cellChange", this.updatePageDots),
        this.on("resize", this.updatePageDots),
        this.on("deactivate", this.deactivatePageDots))
    }
    ,
    n.activatePageDots = function() {
        this.pageDots.activate()
    }
    ,
    n.updateSelectedPageDots = function() {
        this.pageDots.updateSelected()
    }
    ,
    n.updatePageDots = function() {
        this.pageDots.setDots()
    }
    ,
    n.deactivatePageDots = function() {
        this.pageDots.deactivate()
    }
    ,
    e.PageDots = o,
    e
}),
function(t, e) {
    "function" == typeof define && define.amd ? define("flickity/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"], e) : "object" == typeof module && module.exports ? module.exports = e(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : e(t.EvEmitter, t.fizzyUIUtils, t.Flickity)
}(window, function(t, e, i) {
    function n(t) {
        this.parent = t,
        this.state = "stopped",
        this.onVisibilityChange = this.visibilityChange.bind(this),
        this.onVisibilityPlay = this.visibilityPlay.bind(this)
    }
    (n.prototype = Object.create(t.prototype)).play = function() {
        "playing" != this.state && (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : (this.state = "playing",
        document.addEventListener("visibilitychange", this.onVisibilityChange),
        this.tick()))
    }
    ,
    n.prototype.tick = function() {
        var t, e;
        "playing" == this.state && (t = "number" == typeof (t = this.parent.options.autoPlay) ? t : 3e3,
        (e = this).clear(),
        this.timeout = setTimeout(function() {
            e.parent.next(!0),
            e.tick()
        }, t))
    }
    ,
    n.prototype.stop = function() {
        this.state = "stopped",
        this.clear(),
        document.removeEventListener("visibilitychange", this.onVisibilityChange)
    }
    ,
    n.prototype.clear = function() {
        clearTimeout(this.timeout)
    }
    ,
    n.prototype.pause = function() {
        "playing" == this.state && (this.state = "paused",
        this.clear())
    }
    ,
    n.prototype.unpause = function() {
        "paused" == this.state && this.play()
    }
    ,
    n.prototype.visibilityChange = function() {
        this[document.hidden ? "pause" : "unpause"]()
    }
    ,
    n.prototype.visibilityPlay = function() {
        this.play(),
        document.removeEventListener("visibilitychange", this.onVisibilityPlay)
    }
    ,
    e.extend(i.defaults, {
        pauseAutoPlayOnHover: !0
    }),
    i.createMethods.push("_createPlayer");
    e = i.prototype;
    return e._createPlayer = function() {
        this.player = new n(this),
        this.on("activate", this.activatePlayer),
        this.on("uiChange", this.stopPlayer),
        this.on("pointerDown", this.stopPlayer),
        this.on("deactivate", this.deactivatePlayer)
    }
    ,
    e.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(),
        this.element.addEventListener("mouseenter", this))
    }
    ,
    e.playPlayer = function() {
        this.player.play()
    }
    ,
    e.stopPlayer = function() {
        this.player.stop()
    }
    ,
    e.pausePlayer = function() {
        this.player.pause()
    }
    ,
    e.unpausePlayer = function() {
        this.player.unpause()
    }
    ,
    e.deactivatePlayer = function() {
        this.player.stop(),
        this.element.removeEventListener("mouseenter", this)
    }
    ,
    e.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(),
        this.element.addEventListener("mouseleave", this))
    }
    ,
    e.onmouseleave = function() {
        this.player.unpause(),
        this.element.removeEventListener("mouseleave", this)
    }
    ,
    i.Player = n,
    i
}),
function(t, i) {
    "function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", ["./flickity", "fizzy-ui-utils/utils"], function(t, e) {
        return i(0, t, e)
    }) : "object" == typeof module && module.exports ? module.exports = i(0, require("./flickity"), require("fizzy-ui-utils")) : i(0, t.Flickity, t.fizzyUIUtils)
}(window, function(t, e, n) {
    var i = e.prototype;
    return i.insert = function(t, e) {
        var i, n, o, r, s = this._makeCells(t);
        s && s.length && (n = this.cells.length,
        e = void 0 === e ? n : e,
        o = s,
        r = document.createDocumentFragment(),
        o.forEach(function(t) {
            r.appendChild(t.element)
        }),
        i = r,
        (t = e == n) ? this.slider.appendChild(i) : (o = this.cells[e].element,
        this.slider.insertBefore(i, o)),
        0 === e ? this.cells = s.concat(this.cells) : t ? this.cells = this.cells.concat(s) : (n = this.cells.splice(e, n - e),
        this.cells = this.cells.concat(s).concat(n)),
        this._sizeCells(s),
        this.cellChange(e, !0))
    }
    ,
    i.append = function(t) {
        this.insert(t, this.cells.length)
    }
    ,
    i.prepend = function(t) {
        this.insert(t, 0)
    }
    ,
    i.remove = function(t) {
        var i, t = this.getCells(t);
        t && t.length && (i = this.cells.length - 1,
        t.forEach(function(t) {
            t.remove();
            var e = this.cells.indexOf(t);
            i = Math.min(e, i),
            n.removeFrom(this.cells, t)
        }, this),
        this.cellChange(i, !0))
    }
    ,
    i.cellSizeChange = function(t) {
        t = this.getCell(t);
        t && (t.getSize(),
        t = this.cells.indexOf(t),
        this.cellChange(t))
    }
    ,
    i.cellChange = function(t, e) {
        var i = this.selectedElement;
        this._positionCells(t),
        this._getWrapShiftCells(),
        this.setGallerySize();
        i = this.getCell(i);
        i && (this.selectedIndex = this.getCellSlideIndex(i)),
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex),
        this.emitEvent("cellChange", [t]),
        this.select(this.selectedIndex),
        e && this.positionSliderAtSelected()
    }
    ,
    e
}),
function(t) {
    "function" == typeof define && define.amd ? define("flickity/js/index", ["./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell"], t) : "object" == typeof module && module.exports && (module.exports = t(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell")))
}((window,
function(t) {
    return t
}
)),
function(t, e) {
    "function" == typeof define && define.amd ? define(["flickity/js/index", "fizzy-ui-utils/utils"], e) : "object" == typeof module && module.exports ? module.exports = e(require("flickity"), require("fizzy-ui-utils")) : e(t.Flickity, t.fizzyUIUtils)
}(this, function(t, n) {
    var e = t.Slide
      , o = e.prototype.updateTarget;
    e.prototype.updateTarget = function() {
        var i, n;
        o.apply(this, arguments),
        this.parent.options.fade && (i = this.target - this.x,
        n = this.cells[0].x,
        this.cells.forEach(function(t) {
            var e = t.x - n - i;
            t.renderPosition(e)
        }))
    }
    ;
    e = t.prototype;
    t.createMethods.push("_createFade"),
    e._createFade = function() {
        this.fadeIndex = this.selectedIndex,
        this.prevSelectedIndex = this.selectedIndex,
        this.on("select", this.onSelectFade),
        this.on("dragEnd", this.onDragEndFade),
        this.on("settle", this.onSettleFade),
        this.on("activate", this.onActivateFade),
        this.on("deactivate", this.onDeactivateFade)
    }
    ;
    var i = e.updateSlides;
    e.updateSlides = function() {
        i.apply(this, arguments),
        this.options.fade
    }
    ,
    e.onSelectFade = function() {
        this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1),
        this.prevSelectedIndex = this.selectedIndex
    }
    ,
    e.onSettleFade = function() {
        delete this.didDragEnd,
        this.options.fade && this.slides[this.fadeIndex]
    }
    ,
    e.onDragEndFade = function() {
        this.didDragEnd = !0
    }
    ,
    e.onActivateFade = function() {
        this.options.fade && this.element.classList.add("is-fade")
    }
    ,
    e.onDeactivateFade = function() {
        this.options.fade && this.element.classList.remove("is-fade")
    }
    ;
    var r = e.positionSlider;
    e.positionSlider = function() {
        this.options.fade ? (this.fadeSlides(),
        this.dispatchScrollEvent()) : r.apply(this, arguments)
    }
    ;
    var s = e.positionSliderAtSelected;
    e.positionSliderAtSelected = function() {
        this.options.fade && this.setTranslateX(0),
        s.apply(this, arguments)
    }
    ,
    e.fadeSlides = function() {
        var t, e, i;
        this.slides.length < 2 || (t = this.getFadeIndexes(),
        e = this.slides[t.a],
        i = this.slides[t.b],
        i = this.wrapDifference(e.target, i.target),
        e = this.wrapDifference(e.target, -this.x),
        e /= i,
        i = t.a,
        this.isDragging && (i = .5 < e ? t.a : t.b),
        null != this.fadeHideIndex && this.fadeHideIndex != i && this.fadeHideIndex != t.a && (this.fadeHideIndex,
        t.b),
        this.fadeHideIndex = i)
    }
    ,
    e.getFadeIndexes = function() {
        return this.isDragging || this.didDragEnd ? this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes() : {
            a: this.fadeIndex,
            b: this.selectedIndex
        }
    }
    ,
    e.getFadeDragWrapIndexes = function() {
        var t = this.slides.map(function(t, e) {
            return this.getSlideDistance(-this.x, e)
        }, this)
          , e = t.map(function(t) {
            return Math.abs(t)
        })
          , i = Math.min.apply(Math, e)
          , e = e.indexOf(i)
          , i = t[e]
          , t = this.slides.length
          , i = 0 <= i ? 1 : -1;
        return {
            a: e,
            b: n.modulo(e + i, t)
        }
    }
    ,
    e.getFadeDragLimitIndexes = function() {
        for (var t = 0, e = 0; e < this.slides.length - 1; e++) {
            var i = this.slides[e];
            if (-this.x < i.target)
                break;
            t = e
        }
        return {
            a: t,
            b: t + 1
        }
    }
    ,
    e.wrapDifference = function(t, e) {
        var i = e - t;
        if (!this.options.wrapAround)
            return i;
        e = i + this.slideableWidth,
        t = i - this.slideableWidth;
        return Math.abs(e) < Math.abs(i) && (i = e),
        Math.abs(t) < Math.abs(i) && (i = t),
        i
    }
    ;
    var a = e._getWrapShiftCells;
    e._getWrapShiftCells = function() {
        this.options.fade || a.apply(this, arguments)
    }
    ;
    var l = e.shiftWrapCells;
    return e.shiftWrapCells = function() {
        this.options.fade || l.apply(this, arguments)
    }
    ,
    t
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.PhotoSwipe = e()
}(this, function() {
    "use strict";
    return function(p, i, t, e) {
        var f = {
            features: null,
            bind: function(t, e, i, n) {
                var o = (n ? "remove" : "add") + "EventListener";
                e = e.split(" ");
                for (var r = 0; r < e.length; r++)
                    e[r] && t[o](e[r], i, !1)
            },
            isArray: function(t) {
                return t instanceof Array
            },
            createEl: function(t, e) {
                e = document.createElement(e || "div");
                return t && (e.className = t),
                e
            },
            getScrollY: function() {
                var t = window.pageYOffset;
                return void 0 !== t ? t : document.documentElement.scrollTop
            },
            unbind: function(t, e, i) {
                f.bind(t, e, i, !0)
            },
            removeClass: function(t, e) {
                e = new RegExp("(\\s|^)" + e + "(\\s|$)");
                t.className = t.className.replace(e, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
            },
            addClass: function(t, e) {
                f.hasClass(t, e) || (t.className += (t.className ? " " : "") + e)
            },
            hasClass: function(t, e) {
                return t.className && new RegExp("(^|\\s)" + e + "(\\s|$)").test(t.className)
            },
            getChildByClass: function(t, e) {
                for (var i = t.firstChild; i; ) {
                    if (f.hasClass(i, e))
                        return i;
                    i = i.nextSibling
                }
            },
            arraySearch: function(t, e, i) {
                for (var n = t.length; n--; )
                    if (t[n][i] === e)
                        return n;
                return -1
            },
            extend: function(t, e, i) {
                for (var n in e)
                    if (e.hasOwnProperty(n)) {
                        if (i && t.hasOwnProperty(n))
                            continue;
                        t[n] = e[n]
                    }
            },
            easing: {
                sine: {
                    out: function(t) {
                        return Math.sin(t * (Math.PI / 2))
                    },
                    inOut: function(t) {
                        return -(Math.cos(Math.PI * t) - 1) / 2
                    }
                },
                cubic: {
                    out: function(t) {
                        return --t * t * t + 1
                    }
                }
            },
            detectFeatures: function() {
                if (f.features)
                    return f.features;
                var t, e, i = f.createEl().style, n = "", o = {};
                o.oldIE = document.all && !document.addEventListener,
                o.touch = "ontouchstart"in window,
                window.requestAnimationFrame && (o.raf = window.requestAnimationFrame,
                o.caf = window.cancelAnimationFrame),
                o.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled,
                o.pointerEvent || (t = navigator.userAgent,
                !/iP(hone|od)/.test(navigator.platform) || (e = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/)) && 0 < e.length && 1 <= (e = parseInt(e[1], 10)) && e < 8 && (o.isOldIOSPhone = !0),
                e = (e = t.match(/Android\s([0-9\.]*)/)) ? e[1] : 0,
                1 <= (e = parseFloat(e)) && (e < 4.4 && (o.isOldAndroid = !0),
                o.androidVersion = e),
                o.isMobileOpera = /opera mini|opera mobi/i.test(t));
                for (var r, s, a, l = ["transform", "perspective", "animationName"], c = ["", "webkit", "Moz", "ms", "O"], u = 0; u < 4; u++) {
                    n = c[u];
                    for (var d = 0; d < 3; d++)
                        r = l[d],
                        s = n + (n ? r.charAt(0).toUpperCase() + r.slice(1) : r),
                        !o[r] && s in i && (o[r] = s);
                    n && !o.raf && (n = n.toLowerCase(),
                    o.raf = window[n + "RequestAnimationFrame"],
                    o.raf && (o.caf = window[n + "CancelAnimationFrame"] || window[n + "CancelRequestAnimationFrame"]))
                }
                return o.raf || (a = 0,
                o.raf = function(t) {
                    var e = (new Date).getTime()
                      , i = Math.max(0, 16 - (e - a))
                      , n = window.setTimeout(function() {
                        t(e + i)
                    }, i);
                    return a = e + i,
                    n
                }
                ,
                o.caf = function(t) {
                    clearTimeout(t)
                }
                ),
                o.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect,
                f.features = o
            }
        };
        f.detectFeatures(),
        f.features.oldIE && (f.bind = function(t, e, i, n) {
            e = e.split(" ");
            for (var o, r = (n ? "detach" : "attach") + "Event", s = function() {
                i.handleEvent.call(i)
            }, a = 0; a < e.length; a++)
                if (o = e[a])
                    if ("object" == typeof i && i.handleEvent) {
                        if (n) {
                            if (!i["oldIE" + o])
                                return !1
                        } else
                            i["oldIE" + o] = s;
                        t[r]("on" + o, i["oldIE" + o])
                    } else
                        t[r]("on" + o, i)
        }
        );
        var m = this
          , g = {
            allowPanToNext: !0,
            spacing: .12,
            bgOpacity: 1,
            mouseUsed: !1,
            loop: !0,
            pinchToClose: !0,
            closeOnScroll: !0,
            closeOnVerticalDrag: !0,
            verticalDragRange: .75,
            hideAnimationDuration: 333,
            showAnimationDuration: 333,
            showHideOpacity: !1,
            focus: !0,
            escKey: !0,
            arrowKeys: !0,
            mainScrollEndFriction: .35,
            panEndFriction: .35,
            isClickableElement: function(t) {
                return "A" === t.tagName
            },
            getDoubleTapZoom: function(t, e) {
                return t || e.initialZoomLevel < .7 ? 1 : 1.33
            },
            maxSpreadZoom: 1.33,
            modal: !0,
            scaleMode: "fit"
        };
        f.extend(g, e);
        function n(t, e) {
            f.extend(m, e.publicMethods),
            Kt.push(t)
        }
        function s(t) {
            var e = qe();
            return e - 1 < t ? t - e : t < 0 ? e + t : t
        }
        function r(t, e) {
            return Qt[t] || (Qt[t] = []),
            Qt[t].push(e)
        }
        function v(t) {
            var e = Qt[t];
            if (e) {
                var i = Array.prototype.slice.call(arguments);
                i.shift();
                for (var n = 0; n < e.length; n++)
                    e[n].apply(m, i)
            }
        }
        function u() {
            return (new Date).getTime()
        }
        function y(t) {
            Ut = t,
            m.bg.style.opacity = t * g.bgOpacity
        }
        function o(t, e, i, n, o) {
            (!Jt || o && o !== m.currItem) && (n /= (o || m.currItem).fitRatio),
            t[st] = K + e + "px, " + i + "px" + $ + " scale(" + n + ")"
        }
        function d(t, e) {
            var i;
            !g.loop && e && (i = V + (Xt.x * Bt - t) / Xt.x,
            e = Math.round(t - be.x),
            (i < 0 && 0 < e || i >= qe() - 1 && e < 0) && (t = be.x + e * g.mainScrollEndFriction)),
            be.x = t,
            ie(t, H)
        }
        function a(t, e) {
            var i = xe[t] - Zt[t];
            return Vt[t] + Wt[t] + i - e / G * i
        }
        function b(t, e) {
            t.x = e.x,
            t.y = e.y,
            e.id && (t.id = e.id)
        }
        function c(t) {
            t.x = Math.round(t.x),
            t.y = Math.round(t.y)
        }
        function h(t, e) {
            return t = Ge(m.currItem, qt, t),
            e && (Mt = t),
            t
        }
        function l(t) {
            return (t = t || m.currItem).initialZoomLevel
        }
        function x(t) {
            return 0 < (t = t || m.currItem).w ? g.maxSpreadZoom : 1
        }
        function w(t, e, i, n) {
            return n === m.currItem.initialZoomLevel ? (i[t] = m.currItem.initialPosition[t],
            !0) : (i[t] = a(t, n),
            i[t] > e.min[t] ? (i[t] = e.min[t],
            !0) : i[t] < e.max[t] && (i[t] = e.max[t],
            !0))
        }
        function S(t) {
            var e = "";
            g.escKey && 27 === t.keyCode ? e = "close" : g.arrowKeys && (37 === t.keyCode ? e = "prev" : 39 === t.keyCode && (e = "next")),
            e && (t.ctrlKey || t.altKey || t.shiftKey || t.metaKey || (t.preventDefault ? t.preventDefault() : t.returnValue = !1,
            m[e]()))
        }
        function E(t) {
            t && (kt || Dt || Lt || wt) && (t.preventDefault(),
            t.stopPropagation())
        }
        function C() {
            m.setScrollOffset(0, f.getScrollY())
        }
        function D(t) {
            re[t] && (re[t].raf && ut(re[t].raf),
            se--,
            delete re[t])
        }
        function k(t) {
            re[t] && D(t),
            re[t] || (se++,
            re[t] = {})
        }
        function P() {
            for (var t in re)
                re.hasOwnProperty(t) && D(t)
        }
        function _(t, e, i, n, o, r, s) {
            var a, l = u();
            k(t);
            var c = function() {
                if (re[t]) {
                    if ((a = u() - l) >= n)
                        return D(t),
                        r(i),
                        void (s && s());
                    r((i - e) * o(a / n) + e),
                    re[t].raf = ct(c)
                }
            };
            c()
        }
        function I(t, e) {
            return me.x = Math.abs(t.x - e.x),
            me.y = Math.abs(t.y - e.y),
            Math.sqrt(me.x * me.x + me.y * me.y)
        }
        function A(t, e) {
            return De.prevent = !Ce(t.target, g.isClickableElement),
            v("preventDragEvent", t, e, De),
            De.prevent
        }
        function T(t, e) {
            return e.x = t.pageX,
            e.y = t.pageY,
            e.id = t.identifier,
            e
        }
        function M(t, e, i) {
            i.x = .5 * (t.x + e.x),
            i.y = .5 * (t.y + e.y)
        }
        function z() {
            var t = Ht.y - m.currItem.initialPosition.y;
            return 1 - Math.abs(t / (qt.y / 2))
        }
        function L(t) {
            for (; 0 < _e.length; )
                _e.pop();
            return at ? (jt = 0,
            he.forEach(function(t) {
                0 === jt ? _e[0] = t : 1 === jt && (_e[1] = t),
                jt++
            })) : -1 < t.type.indexOf("touch") ? t.touches && 0 < t.touches.length && (_e[0] = T(t.touches[0], ke),
            1 < t.touches.length && (_e[1] = T(t.touches[1], Pe))) : (ke.x = t.pageX,
            ke.y = t.pageY,
            ke.id = "",
            _e[0] = ke),
            _e
        }
        function O(t, e) {
            var i, n, o, r = Ht[t] + e[t], s = 0 < e[t], a = be.x + e.x, l = be.x - pe.x, c = r > Mt.min[t] || r < Mt.max[t] ? g.panEndFriction : 1, r = Ht[t] + e[t] * c;
            if ((g.allowPanToNext || Y === m.currItem.initialZoomLevel) && (zt ? "h" !== Ot || "x" !== t || Dt || (s ? (r > Mt.min[t] && (c = g.panEndFriction,
            Mt.min[t],
            i = Mt.min[t] - Vt[t]),
            (i <= 0 || l < 0) && 1 < qe() ? (o = a,
            l < 0 && a > pe.x && (o = pe.x)) : Mt.min.x !== Mt.max.x && (n = r)) : (r < Mt.max[t] && (c = g.panEndFriction,
            Mt.max[t],
            i = Vt[t] - Mt.max[t]),
            (i <= 0 || 0 < l) && 1 < qe() ? (o = a,
            0 < l && a < pe.x && (o = pe.x)) : Mt.min.x !== Mt.max.x && (n = r))) : o = a,
            "x" === t))
                return void 0 !== o && (d(o, !0),
                _t = o !== pe.x),
                Mt.min.x !== Mt.max.x && (void 0 !== n ? Ht.x = n : _t || (Ht.x += e.x * c)),
                void 0 !== o;
            Lt || _t || Y > m.currItem.fitRatio && (Ht[t] += e[t] * c)
        }
        function F(t) {
            var e;
            "mousedown" === t.type && 0 < t.button || (Ve ? t.preventDefault() : St && "mousedown" === t.type || (A(t, !0) && t.preventDefault(),
            v("pointerDown"),
            at && ((e = f.arraySearch(he, t.pointerId, "id")) < 0 && (e = he.length),
            he[e] = {
                x: t.pageX,
                y: t.pageY,
                id: t.pointerId
            }),
            t = (e = L(t)).length,
            It = null,
            P(),
            Et && 1 !== t || (Et = Ft = !0,
            f.bind(window, B, m),
            xt = Rt = Nt = wt = _t = kt = Ct = Dt = !1,
            Ot = null,
            v("firstTouchStart", e),
            b(Vt, Ht),
            Wt.x = Wt.y = 0,
            b(ue, e[0]),
            b(de, ue),
            pe.x = Xt.x * Bt,
            fe = [{
                x: ue.x,
                y: ue.y
            }],
            yt = vt = u(),
            h(Y, !0),
            Se(),
            Ee()),
            !At && 1 < t && !Lt && !_t && (G = Y,
            At = Ct = !(Dt = !1),
            Wt.y = Wt.x = 0,
            b(Vt, Ht),
            b(ae, e[0]),
            b(le, e[1]),
            M(ae, le, we),
            xe.x = Math.abs(we.x) - Ht.x,
            xe.y = Math.abs(we.y) - Ht.y,
            Tt = I(ae, le))))
        }
        function N(t) {
            var e, i;
            t.preventDefault(),
            at && -1 < (e = f.arraySearch(he, t.pointerId, "id")) && ((i = he[e]).x = t.pageX,
            i.y = t.pageY),
            Et && (i = L(t),
            Ot || kt || At ? It = i : be.x !== Xt.x * Bt ? Ot = "h" : (t = Math.abs(i[0].x - ue.x) - Math.abs(i[0].y - ue.y),
            10 <= Math.abs(t) && (Ot = 0 < t ? "h" : "v",
            It = i)))
        }
        function U(t) {
            if (mt.isOldAndroid) {
                if (St && "mouseup" === t.type)
                    return;
                -1 < t.type.indexOf("touch") && (clearTimeout(St),
                St = setTimeout(function() {
                    St = 0
                }, 600))
            }
            v("pointerUp"),
            A(t, !1) && t.preventDefault(),
            at && -1 < (i = f.arraySearch(he, t.pointerId, "id")) && (r = he.splice(i, 1)[0],
            navigator.msPointerEnabled ? (r.type = {
                4: "mouse",
                2: "touch",
                3: "pen"
            }[t.pointerType],
            r.type || (r.type = t.pointerType || "mouse")) : r.type = t.pointerType || "mouse");
            var e = L(t)
              , i = e.length;
            if ("mouseup" === t.type && (i = 0),
            2 === i)
                return !(It = null);
            1 === i && b(de, e[0]),
            0 !== i || Ot || Lt || (r || ("mouseup" === t.type ? r = {
                x: t.pageX,
                y: t.pageY,
                type: "mouse"
            } : t.changedTouches && t.changedTouches[0] && (r = {
                x: t.changedTouches[0].pageX,
                y: t.changedTouches[0].pageY,
                type: "touch"
            })),
            v("touchRelease", t, r));
            var n, o, r = -1;
            if (0 === i && (Et = !1,
            f.unbind(window, B, m),
            Se(),
            At ? r = 0 : -1 !== ye && (r = u() - ye)),
            ye = 1 === i ? u() : -1,
            r = -1 !== r && r < 150 ? "zoom" : "swipe",
            At && i < 2 && (At = !1,
            1 === i && (r = "zoomPointerUp"),
            v("zoomGestureEnded")),
            It = null,
            kt || Dt || Lt || wt)
                if (P(),
                (bt = bt || Ae()).calculateSwipeSpeed("x"),
                wt)
                    z() < g.verticalDragRange ? m.close() : (n = Ht.y,
                    o = Ut,
                    _("verticalDrag", 0, 1, 300, f.easing.cubic.out, function(t) {
                        Ht.y = (m.currItem.initialPosition.y - n) * t + n,
                        y((1 - o) * t + o),
                        te()
                    }),
                    v("onVerticalDrag", 1));
                else {
                    if ((_t || Lt) && 0 === i) {
                        if (Me(r, bt))
                            return;
                        r = "zoomPointerUp"
                    }
                    Lt || ("swipe" === r ? !_t && Y > m.currItem.fitRatio && Te(bt) : Le())
                }
        }
        var R, j, W, V, H, q, B, Z, X, Y, G, K, $, J, Q, tt, et, it, nt, ot, rt, st, at, lt, ct, ut, dt, ht, pt, ft, mt, gt, vt, yt, bt, xt, wt, St, Et, Ct, Dt, kt, Pt, _t, It, At, Tt, Mt, zt, Lt, Ot, Ft, Nt, Ut, Rt, jt, Wt = {
            x: 0,
            y: 0
        }, Vt = {
            x: 0,
            y: 0
        }, Ht = {
            x: 0,
            y: 0
        }, qt = {}, Bt = 0, Zt = {}, Xt = {
            x: 0,
            y: 0
        }, Yt = 0, Gt = !0, Kt = [], $t = {}, Jt = !1, Qt = {}, te = function(t) {
            zt && (t && (Y > m.currItem.fitRatio ? Jt || (Ke(m.currItem, !1, !0),
            Jt = !0) : Jt && (Ke(m.currItem),
            Jt = !1)),
            o(zt, Ht.x, Ht.y, Y))
        }, ee = function(t) {
            t.container && o(t.container.style, t.initialPosition.x, t.initialPosition.y, t.initialZoomLevel, t)
        }, ie = function(t, e) {
            e[st] = K + t + "px, 0px" + $
        }, ne = null, oe = function() {
            ne && (f.unbind(document, "mousemove", oe),
            f.addClass(p, "pswp--has_mouse"),
            g.mouseUsed = !0,
            v("mouseUsed")),
            ne = setTimeout(function() {
                ne = null
            }, 100)
        }, re = {}, se = 0, e = {
            shout: v,
            listen: r,
            viewportSize: qt,
            options: g,
            isMainScrollAnimating: function() {
                return Lt
            },
            getZoomLevel: function() {
                return Y
            },
            getCurrentIndex: function() {
                return V
            },
            isDragging: function() {
                return Et
            },
            isZooming: function() {
                return At
            },
            setScrollOffset: function(t, e) {
                Zt.x = t,
                ft = Zt.y = e,
                v("updateScrollOffset", Zt)
            },
            applyZoomPan: function(t, e, i, n) {
                Ht.x = e,
                Ht.y = i,
                Y = t,
                te(n)
            },
            init: function() {
                if (!R && !j) {
                    var t;
                    m.framework = f,
                    m.template = p,
                    m.bg = f.getChildByClass(p, "pswp__bg"),
                    dt = p.className,
                    R = !0,
                    mt = f.detectFeatures(),
                    ct = mt.raf,
                    ut = mt.caf,
                    st = mt.transform,
                    pt = mt.oldIE,
                    m.scrollWrap = f.getChildByClass(p, "pswp__scroll-wrap"),
                    m.container = f.getChildByClass(m.scrollWrap, "pswp__container"),
                    H = m.container.style,
                    m.itemHolders = tt = [{
                        el: m.container.children[0],
                        wrap: 0,
                        index: -1
                    }, {
                        el: m.container.children[1],
                        wrap: 0,
                        index: -1
                    }, {
                        el: m.container.children[2],
                        wrap: 0,
                        index: -1
                    }],
                    tt[0].el.style.display = tt[2].el.style.display = "none",
                    function() {
                        if (st) {
                            var t = mt.perspective && !lt;
                            return K = "translate" + (t ? "3d(" : "("),
                            $ = mt.perspective ? ", 0px)" : ")"
                        }
                        st = "left",
                        f.addClass(p, "pswp--ie"),
                        ie = function(t, e) {
                            e.left = t + "px"
                        }
                        ,
                        ee = function(t) {
                            var e = 1 < t.fitRatio ? 1 : t.fitRatio
                              , i = t.container.style
                              , n = e * t.w
                              , e = e * t.h;
                            i.width = n + "px",
                            i.height = e + "px",
                            i.left = t.initialPosition.x + "px",
                            i.top = t.initialPosition.y + "px"
                        }
                        ,
                        te = function() {
                            var t, e, i, n;
                            zt && (t = zt,
                            i = (e = 1 < (n = m.currItem).fitRatio ? 1 : n.fitRatio) * n.w,
                            n = e * n.h,
                            t.width = i + "px",
                            t.height = n + "px",
                            t.left = Ht.x + "px",
                            t.top = Ht.y + "px")
                        }
                    }(),
                    X = {
                        resize: m.updateSize,
                        orientationchange: function() {
                            clearTimeout(gt),
                            gt = setTimeout(function() {
                                qt.x !== m.scrollWrap.clientWidth && m.updateSize()
                            }, 500)
                        },
                        scroll: C,
                        keydown: S,
                        click: E
                    };
                    var e = mt.isOldIOSPhone || mt.isOldAndroid || mt.isMobileOpera;
                    for (mt.animationName && mt.transform && !e || (g.showAnimationDuration = g.hideAnimationDuration = 0),
                    t = 0; t < Kt.length; t++)
                        m["init" + Kt[t]]();
                    i && (m.ui = new i(m,f)).init(),
                    v("firstUpdate"),
                    V = V || g.index || 0,
                    (isNaN(V) || V < 0 || V >= qe()) && (V = 0),
                    m.currItem = He(V),
                    (mt.isOldIOSPhone || mt.isOldAndroid) && (Gt = !1),
                    p.setAttribute("aria-hidden", "false"),
                    g.modal && (Gt ? p.style.position = "fixed" : (p.style.position = "absolute",
                    p.style.top = f.getScrollY() + "px")),
                    void 0 === ft && (v("initialLayout"),
                    ft = ht = f.getScrollY());
                    e = "pswp--open ";
                    for (g.mainClass && (e += g.mainClass + " "),
                    g.showHideOpacity && (e += "pswp--animate_opacity "),
                    e += lt ? "pswp--touch" : "pswp--notouch",
                    e += mt.animationName ? " pswp--css_animation" : "",
                    e += mt.svg ? " pswp--svg" : "",
                    f.addClass(p, e),
                    m.updateSize(),
                    q = -1,
                    Yt = null,
                    t = 0; t < 3; t++)
                        ie((t + q) * Xt.x, tt[t].el.style);
                    pt || f.bind(m.scrollWrap, Z, m),
                    r("initialZoomInEnd", function() {
                        m.setContent(tt[0], V - 1),
                        m.setContent(tt[2], V + 1),
                        tt[0].el.style.display = tt[2].el.style.display = "block",
                        g.focus && p.focus(),
                        f.bind(document, "keydown", m),
                        mt.transform && f.bind(m.scrollWrap, "click", m),
                        g.mouseUsed || f.bind(document, "mousemove", oe),
                        f.bind(window, "resize scroll orientationchange", m),
                        v("bindEvents")
                    }),
                    m.setContent(tt[1], V),
                    m.updateCurrItem(),
                    v("afterInit"),
                    Gt || (J = setInterval(function() {
                        se || Et || At || Y !== m.currItem.initialZoomLevel || m.updateSize()
                    }, 1e3)),
                    f.addClass(p, "pswp--visible")
                }
            },
            close: function() {
                R && (j = !(R = !1),
                v("close"),
                f.unbind(window, "resize scroll orientationchange", m),
                f.unbind(window, "scroll", X.scroll),
                f.unbind(document, "keydown", m),
                f.unbind(document, "mousemove", oe),
                mt.transform && f.unbind(m.scrollWrap, "click", m),
                Et && f.unbind(window, B, m),
                clearTimeout(gt),
                v("unbindEvents"),
                Be(m.currItem, null, !0, m.destroy))
            },
            destroy: function() {
                v("destroy"),
                Re && clearTimeout(Re),
                p.setAttribute("aria-hidden", "true"),
                p.className = dt,
                J && clearInterval(J),
                f.unbind(m.scrollWrap, Z, m),
                f.unbind(window, "scroll", m),
                Se(),
                P(),
                Qt = null
            },
            panTo: function(t, e, i) {
                i || (t > Mt.min.x ? t = Mt.min.x : t < Mt.max.x && (t = Mt.max.x),
                e > Mt.min.y ? e = Mt.min.y : e < Mt.max.y && (e = Mt.max.y)),
                Ht.x = t,
                Ht.y = e,
                te()
            },
            handleEvent: function(t) {
                t = t || window.event,
                X[t.type] && X[t.type](t)
            },
            goTo: function(t) {
                var e = (t = s(t)) - V;
                Yt = e,
                V = t,
                m.currItem = He(V),
                Bt -= e,
                d(Xt.x * Bt),
                P(),
                Lt = !1,
                m.updateCurrItem()
            },
            next: function() {
                m.goTo(V + 1)
            },
            prev: function() {
                m.goTo(V - 1)
            },
            updateCurrZoomItem: function(t) {
                var e;
                t && v("beforeChange", 0),
                zt = tt[1].el.children.length ? (e = tt[1].el.children[0],
                f.hasClass(e, "pswp__zoom-wrap") ? e.style : null) : null,
                Mt = m.currItem.bounds,
                G = Y = m.currItem.initialZoomLevel,
                Ht.x = Mt.center.x,
                Ht.y = Mt.center.y,
                t && v("afterChange")
            },
            invalidateCurrItems: function() {
                Q = !0;
                for (var t = 0; t < 3; t++)
                    tt[t].item && (tt[t].item.needsUpdate = !0)
            },
            updateCurrItem: function(t) {
                if (0 !== Yt) {
                    var e, i = Math.abs(Yt);
                    if (!(t && i < 2)) {
                        m.currItem = He(V),
                        Jt = !1,
                        v("beforeChange", Yt),
                        3 <= i && (q += Yt + (0 < Yt ? -3 : 3),
                        i = 3);
                        for (var n = 0; n < i; n++)
                            0 < Yt ? (e = tt.shift(),
                            tt[2] = e,
                            ie((++q + 2) * Xt.x, e.el.style),
                            m.setContent(e, V - i + n + 1 + 1)) : (e = tt.pop(),
                            tt.unshift(e),
                            ie(--q * Xt.x, e.el.style),
                            m.setContent(e, V + i - n - 1 - 1));
                        !zt || 1 !== Math.abs(Yt) || (t = He(et)).initialZoomLevel !== Y && (Ge(t, qt),
                        Ke(t),
                        ee(t)),
                        Yt = 0,
                        m.updateCurrZoomItem(),
                        et = V,
                        v("afterChange")
                    }
                }
            },
            updateSize: function(t) {
                if (!Gt && g.modal) {
                    var e = f.getScrollY();
                    if (ft !== e && (p.style.top = e + "px",
                    ft = e),
                    !t && $t.x === window.innerWidth && $t.y === window.innerHeight)
                        return;
                    $t.x = window.innerWidth,
                    $t.y = window.innerHeight,
                    p.style.height = $t.y + "px"
                }
                if (qt.x = m.scrollWrap.clientWidth,
                qt.y = m.scrollWrap.clientHeight,
                C(),
                Xt.x = qt.x + Math.round(qt.x * g.spacing),
                Xt.y = qt.y,
                d(Xt.x * Bt),
                v("beforeResize"),
                void 0 !== q) {
                    for (var i, n, o, r = 0; r < 3; r++)
                        i = tt[r],
                        ie((r + q) * Xt.x, i.el.style),
                        o = V + r - 1,
                        g.loop && 2 < qe() && (o = s(o)),
                        (n = He(o)) && (Q || n.needsUpdate || !n.bounds) ? (m.cleanSlide(n),
                        m.setContent(i, o),
                        1 === r && (m.currItem = n,
                        m.updateCurrZoomItem(!0)),
                        n.needsUpdate = !1) : -1 === i.index && 0 <= o && m.setContent(i, o),
                        n && n.container && (Ge(n, qt),
                        Ke(n),
                        ee(n));
                    Q = !1
                }
                G = Y = m.currItem.initialZoomLevel,
                (Mt = m.currItem.bounds) && (Ht.x = Mt.center.x,
                Ht.y = Mt.center.y,
                te(!0)),
                v("resize")
            },
            zoomTo: function(e, t, i, n, o) {
                t && (G = Y,
                xe.x = Math.abs(t.x) - Ht.x,
                xe.y = Math.abs(t.y) - Ht.y,
                b(Vt, Ht));
                var t = h(e, !1)
                  , r = {};
                w("x", t, r, e),
                w("y", t, r, e);
                var s = Y
                  , a = Ht.x
                  , l = Ht.y;
                c(r);
                t = function(t) {
                    1 === t ? (Y = e,
                    Ht.x = r.x,
                    Ht.y = r.y) : (Y = (e - s) * t + s,
                    Ht.x = (r.x - a) * t + a,
                    Ht.y = (r.y - l) * t + l),
                    o && o(t),
                    te(1 === t)
                }
                ;
                i ? _("customZoomTo", 0, 1, i, n || f.easing.sine.inOut, t) : t(1)
            }
        }, ae = {}, le = {}, ce = {}, ue = {}, de = {}, he = [], pe = {}, fe = [], me = {}, ge = 0, ve = {
            x: 0,
            y: 0
        }, ye = 0, be = {
            x: 0,
            y: 0
        }, xe = {
            x: 0,
            y: 0
        }, we = {
            x: 0,
            y: 0
        }, Se = function() {
            Pt && (ut(Pt),
            Pt = null)
        }, Ee = function() {
            Et && (Pt = ct(Ee),
            Ie())
        }, Ce = function(t, e) {
            return !(!t || t === document) && !(t.getAttribute("class") && -1 < t.getAttribute("class").indexOf("pswp__scroll-wrap")) && (e(t) ? t : Ce(t.parentNode, e))
        }, De = {}, ke = {}, Pe = {}, _e = [], Ie = function() {
            if (It) {
                var t = It.length;
                if (0 !== t)
                    if (b(ae, It[0]),
                    ce.x = ae.x - ue.x,
                    ce.y = ae.y - ue.y,
                    At && 1 < t)
                        ue.x = ae.x,
                        ue.y = ae.y,
                        (ce.x || ce.y || ((r = It[1]).x !== le.x || r.y !== le.y)) && (b(le, It[1]),
                        Dt || (Dt = !0,
                        v("zoomGestureStarted")),
                        t = I(ae, le),
                        (o = ze(t)) > m.currItem.initialZoomLevel + m.currItem.initialZoomLevel / 15 && (Rt = !0),
                        n = 1,
                        i = l(),
                        r = x(),
                        o < i ? g.pinchToClose && !Rt && G <= m.currItem.initialZoomLevel ? (y(t = 1 - (i - o) / (i / 1.2)),
                        v("onPinchClose", t),
                        Nt = !0) : (1 < (n = (i - o) / i) && (n = 1),
                        o = i - n * (i / 3)) : r < o && (1 < (n = (o - r) / (6 * i)) && (n = 1),
                        o = r + n * i),
                        n < 0 && (n = 0),
                        M(ae, le, ve),
                        Wt.x += ve.x - we.x,
                        Wt.y += ve.y - we.y,
                        b(we, ve),
                        Ht.x = a("x", o),
                        Ht.y = a("y", o),
                        xt = Y < o,
                        Y = o,
                        te());
                    else if (Ot && (Ft && (Ft = !1,
                    10 <= Math.abs(ce.x) && (ce.x -= It[0].x - de.x),
                    10 <= Math.abs(ce.y) && (ce.y -= It[0].y - de.y)),
                    ue.x = ae.x,
                    ue.y = ae.y,
                    0 !== ce.x || 0 !== ce.y)) {
                        if ("v" === Ot && g.closeOnVerticalDrag && "fit" === g.scaleMode && Y === m.currItem.initialZoomLevel) {
                            Wt.y += ce.y,
                            Ht.y += ce.y;
                            var e = z();
                            return wt = !0,
                            v("onVerticalDrag", e),
                            y(e),
                            void te()
                        }
                        i = u(),
                        n = ae.x,
                        o = ae.y,
                        50 < i - yt && ((e = 2 < fe.length ? fe.shift() : {}).x = n,
                        e.y = o,
                        fe.push(e),
                        yt = i),
                        kt = !0,
                        Mt = m.currItem.bounds,
                        O("x", ce) || (O("y", ce),
                        c(Ht),
                        te())
                    }
            }
            var i, n, o, r
        }, Ae = function() {
            var e, i, n = {
                lastFlickOffset: {},
                lastFlickDist: {},
                lastFlickSpeed: {},
                slowDownRatio: {},
                slowDownRatioReverse: {},
                speedDecelerationRatio: {},
                speedDecelerationRatioAbs: {},
                distanceOffset: {},
                backAnimDestination: {},
                backAnimStarted: {},
                calculateSwipeSpeed: function(t) {
                    i = 1 < fe.length ? (e = u() - yt + 50,
                    fe[fe.length - 2][t]) : (e = u() - vt,
                    de[t]),
                    n.lastFlickOffset[t] = ue[t] - i,
                    n.lastFlickDist[t] = Math.abs(n.lastFlickOffset[t]),
                    20 < n.lastFlickDist[t] ? n.lastFlickSpeed[t] = n.lastFlickOffset[t] / e : n.lastFlickSpeed[t] = 0,
                    Math.abs(n.lastFlickSpeed[t]) < .1 && (n.lastFlickSpeed[t] = 0),
                    n.slowDownRatio[t] = .95,
                    n.slowDownRatioReverse[t] = 1 - n.slowDownRatio[t],
                    n.speedDecelerationRatio[t] = 1
                },
                calculateOverBoundsAnimOffset: function(e, t) {
                    n.backAnimStarted[e] || (Ht[e] > Mt.min[e] ? n.backAnimDestination[e] = Mt.min[e] : Ht[e] < Mt.max[e] && (n.backAnimDestination[e] = Mt.max[e]),
                    void 0 !== n.backAnimDestination[e] && (n.slowDownRatio[e] = .7,
                    n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e],
                    n.speedDecelerationRatioAbs[e] < .05 && (n.lastFlickSpeed[e] = 0,
                    n.backAnimStarted[e] = !0,
                    _("bounceZoomPan" + e, Ht[e], n.backAnimDestination[e], t || 300, f.easing.sine.out, function(t) {
                        Ht[e] = t,
                        te()
                    }))))
                },
                calculateAnimOffset: function(t) {
                    n.backAnimStarted[t] || (n.speedDecelerationRatio[t] = n.speedDecelerationRatio[t] * (n.slowDownRatio[t] + n.slowDownRatioReverse[t] - n.slowDownRatioReverse[t] * n.timeDiff / 10),
                    n.speedDecelerationRatioAbs[t] = Math.abs(n.lastFlickSpeed[t] * n.speedDecelerationRatio[t]),
                    n.distanceOffset[t] = n.lastFlickSpeed[t] * n.speedDecelerationRatio[t] * n.timeDiff,
                    Ht[t] += n.distanceOffset[t])
                },
                panAnimLoop: function() {
                    if (re.zoomPan && (re.zoomPan.raf = ct(n.panAnimLoop),
                    n.now = u(),
                    n.timeDiff = n.now - n.lastNow,
                    n.lastNow = n.now,
                    n.calculateAnimOffset("x"),
                    n.calculateAnimOffset("y"),
                    te(),
                    n.calculateOverBoundsAnimOffset("x"),
                    n.calculateOverBoundsAnimOffset("y"),
                    n.speedDecelerationRatioAbs.x < .05 && n.speedDecelerationRatioAbs.y < .05))
                        return Ht.x = Math.round(Ht.x),
                        Ht.y = Math.round(Ht.y),
                        te(),
                        void D("zoomPan")
                }
            };
            return n
        }, Te = function(t) {
            if (t.calculateSwipeSpeed("y"),
            Mt = m.currItem.bounds,
            t.backAnimDestination = {},
            t.backAnimStarted = {},
            Math.abs(t.lastFlickSpeed.x) <= .05 && Math.abs(t.lastFlickSpeed.y) <= .05)
                return t.speedDecelerationRatioAbs.x = t.speedDecelerationRatioAbs.y = 0,
                t.calculateOverBoundsAnimOffset("x"),
                t.calculateOverBoundsAnimOffset("y"),
                !0;
            k("zoomPan"),
            t.lastNow = u(),
            t.panAnimLoop()
        }, Me = function(t, e) {
            var i, n;
            Lt || (ge = V),
            "swipe" === t && (n = ue.x - de.x,
            t = e.lastFlickDist.x < 10,
            30 < n && (t || 20 < e.lastFlickOffset.x) ? r = -1 : n < -30 && (t || e.lastFlickOffset.x < -20) && (r = 1)),
            r && ((V += r) < 0 ? (V = g.loop ? qe() - 1 : 0,
            o = !0) : V >= qe() && (V = g.loop ? 0 : qe() - 1,
            o = !0),
            o && !g.loop || (Yt += r,
            Bt -= r,
            i = !0));
            var o = Xt.x * Bt
              , r = Math.abs(o - be.x)
              , s = i || o > be.x == 0 < e.lastFlickSpeed.x ? (s = 0 < Math.abs(e.lastFlickSpeed.x) ? r / Math.abs(e.lastFlickSpeed.x) : 333,
            s = Math.min(s, 400),
            Math.max(s, 250)) : 333;
            return ge === V && (i = !1),
            Lt = !0,
            v("mainScrollAnimStart"),
            _("mainScroll", be.x, o, s, f.easing.cubic.out, d, function() {
                P(),
                Lt = !1,
                ge = -1,
                !i && ge === V || m.updateCurrItem(),
                v("mainScrollAnimComplete")
            }),
            i && m.updateCurrItem(!0),
            i
        }, ze = function(t) {
            return 1 / Tt * t * G
        }, Le = function() {
            var t = Y
              , e = l()
              , i = x();
            Y < e ? t = e : i < Y && (t = i);
            var n, o = Ut;
            return Nt && !xt && !Rt && Y < e ? m.close() : (Nt && (n = function(t) {
                y((1 - o) * t + o)
            }
            ),
            m.zoomTo(t, 0, 200, f.easing.cubic.out, n)),
            !0
        };
        n("Gestures", {
            publicMethods: {
                initGestures: function() {
                    function t(t, e, i, n, o) {
                        it = t + e,
                        nt = t + i,
                        ot = t + n,
                        rt = o ? t + o : ""
                    }
                    (at = mt.pointerEvent) && mt.touch && (mt.touch = !1),
                    at ? navigator.msPointerEnabled ? t("MSPointer", "Down", "Move", "Up", "Cancel") : t("pointer", "down", "move", "up", "cancel") : mt.touch ? (t("touch", "start", "move", "end", "cancel"),
                    lt = !0) : t("mouse", "down", "move", "up"),
                    B = nt + " " + ot + " " + rt,
                    Z = it,
                    at && !lt && (lt = 1 < navigator.maxTouchPoints || 1 < navigator.msMaxTouchPoints),
                    m.likelyTouchDevice = lt,
                    X[it] = F,
                    X[nt] = N,
                    X[ot] = U,
                    rt && (X[rt] = X[ot]),
                    mt.touch && (Z += " mousedown",
                    B += " mousemove mouseup",
                    X.mousedown = X[it],
                    X.mousemove = X[nt],
                    X.mouseup = X[ot]),
                    lt || (g.allowPanToNext = !1)
                }
            }
        });
        function Oe(t, e, i, n, o, r) {
            e.loadError || n && (e.imageAppended = !0,
            Ke(e, n, e === m.currItem && Jt),
            i.appendChild(n),
            r && setTimeout(function() {
                e && e.loaded && e.placeholder && (e.placeholder.style.display = "none",
                e.placeholder = null)
            }, 500))
        }
        function Fe(t) {
            function e() {
                t.loading = !1,
                t.loaded = !0,
                t.loadComplete ? t.loadComplete(t) : t.img = null,
                i.onload = i.onerror = null,
                i = null
            }
            t.loading = !0,
            t.loaded = !1;
            var i = t.img = f.createEl("pswp__img", "img");
            return i.onload = e,
            i.onerror = function() {
                t.loadError = !0,
                e()
            }
            ,
            i.src = t.src,
            i
        }
        function Ne(t, e) {
            return t.src && t.loadError && t.container && (e && (t.container.innerHTML = ""),
            t.container.innerHTML = g.errorMsg.replace("%url%", t.src),
            1)
        }
        function Ue() {
            if (Xe.length) {
                for (var t, e = 0; e < Xe.length; e++)
                    (t = Xe[e]).holder.index === t.index && Oe(t.index, t.item, t.baseDiv, t.img, 0, t.clearPlaceholder);
                Xe = []
            }
        }
        var Re, je, We, Ve, He, qe, Be = function(s, t, a, e) {
            var l;
            Re && clearTimeout(Re),
            We = Ve = !0,
            s.initialLayout ? (l = s.initialLayout,
            s.initialLayout = null) : l = g.getThumbBoundsFn && g.getThumbBoundsFn(V);
            function c() {
                D("initialZoom"),
                a ? (m.template.removeAttribute("style"),
                m.bg.removeAttribute("style")) : (y(1),
                t && (t.style.display = "block"),
                f.addClass(p, "pswp--animated-in"),
                v("initialZoom" + (a ? "OutEnd" : "InEnd"))),
                e && e(),
                Ve = !1
            }
            var u, d, h = a ? g.hideAnimationDuration : g.showAnimationDuration;
            if (!h || !l || void 0 === l.x)
                return v("initialZoom" + (a ? "Out" : "In")),
                Y = s.initialZoomLevel,
                b(Ht, s.initialPosition),
                te(),
                p.style.opacity = a ? 0 : 1,
                y(1),
                void (h ? setTimeout(function() {
                    c()
                }, h) : c());
            u = W,
            d = !m.currItem.src || m.currItem.loadError || g.showHideOpacity,
            s.miniImg && (s.miniImg.style.webkitBackfaceVisibility = "hidden"),
            a || (Y = l.w / s.w,
            Ht.x = l.x,
            Ht.y = l.y - ht,
            m[d ? "template" : "bg"].style.opacity = .001,
            te()),
            k("initialZoom"),
            a && !u && f.removeClass(p, "pswp--animated-in"),
            d && (a ? f[(u ? "remove" : "add") + "Class"](p, "pswp--animate_opacity") : setTimeout(function() {
                f.addClass(p, "pswp--animate_opacity")
            }, 30)),
            Re = setTimeout(function() {
                var e, i, n, o, r, t;
                v("initialZoom" + (a ? "Out" : "In")),
                a ? (e = l.w / s.w,
                i = Ht.x,
                n = Ht.y,
                o = Y,
                r = Ut,
                t = function(t) {
                    1 === t ? (Y = e,
                    Ht.x = l.x,
                    Ht.y = l.y - ft) : (Y = (e - o) * t + o,
                    Ht.x = (l.x - i) * t + i,
                    Ht.y = (l.y - ft - n) * t + n),
                    te(),
                    d ? p.style.opacity = 1 - t : y(r - t * r)
                }
                ,
                u ? _("initialZoom", 0, 1, h, f.easing.cubic.out, t, c) : (t(1),
                Re = setTimeout(c, h + 20))) : (Y = s.initialZoomLevel,
                b(Ht, s.initialPosition),
                te(),
                y(1),
                d ? p.style.opacity = 1 : y(1),
                Re = setTimeout(c, h + 20))
            }, a ? 25 : 90)
        }, Ze = {}, Xe = [], Ye = {
            index: 0,
            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
            forceProgressiveLoading: !1,
            preload: [1, 1],
            getNumItemsFn: function() {
                return je.length
            }
        }, Ge = function(t, e, i) {
            if (!t.src || t.loadError)
                return t.w = t.h = 0,
                t.initialZoomLevel = t.fitRatio = 1,
                t.bounds = {
                    center: {
                        x: 0,
                        y: 0
                    },
                    max: {
                        x: 0,
                        y: 0
                    },
                    min: {
                        x: 0,
                        y: 0
                    }
                },
                t.initialPosition = t.bounds.center,
                t.bounds;
            var n, o, r, s = !i;
            return s && (t.vGap || (t.vGap = {
                top: 0,
                bottom: 0
            }),
            v("parseVerticalMargin", t)),
            Ze.x = e.x,
            Ze.y = e.y - t.vGap.top - t.vGap.bottom,
            s && (n = Ze.x / t.w,
            o = Ze.y / t.h,
            t.fitRatio = n < o ? n : o,
            "orig" === (r = g.scaleMode) ? i = 1 : "fit" === r ? i = t.fitRatio : "zoom" === r && (i = Math.max(t.initialZoomLevel || 1, t.fitRatio)),
            1 < i && (i = 1),
            t.initialZoomLevel = i,
            t.bounds || (t.bounds = {
                center: {
                    x: 0,
                    y: 0
                },
                max: {
                    x: 0,
                    y: 0
                },
                min: {
                    x: 0,
                    y: 0
                }
            })),
            i ? (n = (e = t).w * i,
            o = t.h * i,
            (r = e.bounds).center.x = Math.round((Ze.x - n) / 2),
            r.center.y = Math.round((Ze.y - o) / 2) + e.vGap.top,
            r.max.x = n > Ze.x ? Math.round(Ze.x - n) : r.center.x,
            r.max.y = o > Ze.y ? Math.round(Ze.y - o) + e.vGap.top : r.center.y,
            r.min.x = n > Ze.x ? 0 : r.center.x,
            r.min.y = o > Ze.y ? e.vGap.top : r.center.y,
            s && i === t.initialZoomLevel && (t.initialPosition = t.bounds.center),
            t.bounds) : void 0
        }, Ke = function(t, e, i) {
            var n;
            t.src && (e = e || t.container.lastChild,
            n = i ? t.w : Math.round(t.w * t.fitRatio),
            i = i ? t.h : Math.round(t.h * t.fitRatio),
            t.placeholder && !t.loaded && (t.placeholder.style.width = n + "px",
            t.placeholder.style.height = i + "px"),
            e.style.width = n + "px",
            e.style.height = i + "px")
        };
        n("Controller", {
            publicMethods: {
                lazyLoadItem: function(t) {
                    t = s(t);
                    var e = He(t);
                    e && (!e.loaded && !e.loading || Q) && (v("gettingData", t, e),
                    e.src && Fe(e))
                },
                initController: function() {
                    f.extend(g, Ye, !0),
                    m.items = je = t,
                    He = m.getItemAt,
                    qe = g.getNumItemsFn,
                    g.loop,
                    qe() < 3 && (g.loop = !1),
                    r("beforeChange", function(t) {
                        for (var e = g.preload, i = null === t || 0 <= t, n = Math.min(e[0], qe()), o = Math.min(e[1], qe()), r = 1; r <= (i ? o : n); r++)
                            m.lazyLoadItem(V + r);
                        for (r = 1; r <= (i ? n : o); r++)
                            m.lazyLoadItem(V - r)
                    }),
                    r("initialLayout", function() {
                        m.currItem.initialLayout = g.getThumbBoundsFn && g.getThumbBoundsFn(V)
                    }),
                    r("mainScrollAnimComplete", Ue),
                    r("initialZoomInEnd", Ue),
                    r("destroy", function() {
                        for (var t, e = 0; e < je.length; e++)
                            (t = je[e]).container && (t.container = null),
                            t.placeholder && (t.placeholder = null),
                            t.img && (t.img = null),
                            t.preloader && (t.preloader = null),
                            t.loadError && (t.loaded = t.loadError = !1);
                        Xe = null
                    })
                },
                getItemAt: function(t) {
                    return 0 <= t && void 0 !== je[t] && je[t]
                },
                allowProgressiveImg: function() {
                    return g.forceProgressiveLoading || !lt || g.mouseUsed || 1200 < screen.width
                },
                setContent: function(e, i) {
                    g.loop && (i = s(i));
                    var t = m.getItemAt(e.index);
                    t && (t.container = null);
                    var n, o, r = m.getItemAt(i);
                    r ? (v("gettingData", i, r),
                    e.index = i,
                    o = (e.item = r).container = f.createEl("pswp__zoom-wrap"),
                    !r.src && r.html && (r.html.tagName ? o.appendChild(r.html) : o.innerHTML = r.html),
                    Ne(r),
                    Ge(r, qt),
                    !r.src || r.loadError || r.loaded ? r.src && !r.loadError && ((n = f.createEl("pswp__img", "img")).style.opacity = 1,
                    n.src = r.src,
                    Ke(r, n),
                    Oe(0, r, o, n)) : (r.loadComplete = function(t) {
                        if (R) {
                            if (e && e.index === i) {
                                if (Ne(t, !0))
                                    return t.loadComplete = t.img = null,
                                    Ge(t, qt),
                                    ee(t),
                                    void (e.index === V && m.updateCurrZoomItem());
                                t.imageAppended ? !Ve && t.placeholder && (t.placeholder.style.display = "none",
                                t.placeholder = null) : mt.transform && (Lt || Ve) ? Xe.push({
                                    item: t,
                                    baseDiv: o,
                                    img: t.img,
                                    index: i,
                                    holder: e,
                                    clearPlaceholder: !0
                                }) : Oe(0, t, o, t.img, 0, !0)
                            }
                            t.loadComplete = null,
                            t.img = null,
                            v("imageLoadComplete", i, t)
                        }
                    }
                    ,
                    f.features.transform && (t = "pswp__img pswp__img--placeholder",
                    t += r.msrc ? "" : " pswp__img--placeholder--blank",
                    t = f.createEl(t, r.msrc ? "img" : ""),
                    r.msrc && (t.src = r.msrc),
                    Ke(r, t),
                    o.appendChild(t),
                    r.placeholder = t),
                    r.loading || Fe(r),
                    m.allowProgressiveImg() && (!We && mt.transform ? Xe.push({
                        item: r,
                        baseDiv: o,
                        img: r.img,
                        index: i,
                        holder: e
                    }) : Oe(0, r, o, r.img, 0, !0))),
                    We || i !== V ? ee(r) : (zt = o.style,
                    Be(r, n || r.img)),
                    e.el.innerHTML = "",
                    e.el.appendChild(o)) : e.el.innerHTML = ""
                },
                cleanSlide: function(t) {
                    t.img && (t.img.onload = t.img.onerror = null),
                    t.loaded = t.loading = t.img = t.imageAppended = !1
                }
            }
        });
        function $e(t, e, i) {
            var n = document.createEvent("CustomEvent")
              , i = {
                origEvent: t,
                target: t.target,
                releasePoint: e,
                pointerType: i || "touch"
            };
            n.initCustomEvent("pswpTap", !0, !0, i),
            t.target.dispatchEvent(n)
        }
        var Je, Qe, ti = {};
        n("Tap", {
            publicMethods: {
                initTap: function() {
                    r("firstTouchStart", m.onTapStart),
                    r("touchRelease", m.onTapRelease),
                    r("destroy", function() {
                        ti = {},
                        Je = null
                    })
                },
                onTapStart: function(t) {
                    1 < t.length && (clearTimeout(Je),
                    Je = null)
                },
                onTapRelease: function(t, e) {
                    var i, n, o;
                    !e || kt || Ct || se || (o = e,
                    Je && (clearTimeout(Je),
                    Je = null,
                    i = o,
                    n = ti,
                    Math.abs(i.x - n.x) < 25 && Math.abs(i.y - n.y) < 25) ? v("doubleTap", o) : "mouse" !== e.type ? "BUTTON" === t.target.tagName.toUpperCase() || f.hasClass(t.target, "pswp__single-tap") ? $e(t, e) : (b(ti, o),
                    Je = setTimeout(function() {
                        $e(t, e),
                        Je = null
                    }, 300)) : $e(t, e, "mouse"))
                }
            }
        }),
        n("DesktopZoom", {
            publicMethods: {
                initDesktopZoom: function() {
                    pt || (lt ? r("mouseUsed", function() {
                        m.setupDesktopZoom()
                    }) : m.setupDesktopZoom(!0))
                },
                setupDesktopZoom: function(t) {
                    Qe = {};
                    var e = "wheel mousewheel DOMMouseScroll";
                    r("bindEvents", function() {
                        f.bind(p, e, m.handleMouseWheel)
                    }),
                    r("unbindEvents", function() {
                        Qe && f.unbind(p, e, m.handleMouseWheel)
                    }),
                    m.mouseZoomedIn = !1;
                    function i() {
                        m.mouseZoomedIn && (f.removeClass(p, "pswp--zoomed-in"),
                        m.mouseZoomedIn = !1),
                        Y < 1 ? f.addClass(p, "pswp--zoom-allowed") : f.removeClass(p, "pswp--zoom-allowed"),
                        o()
                    }
                    var n, o = function() {
                        n && (f.removeClass(p, "pswp--dragging"),
                        n = !1)
                    };
                    r("resize", i),
                    r("afterChange", i),
                    r("pointerDown", function() {
                        m.mouseZoomedIn && (n = !0,
                        f.addClass(p, "pswp--dragging"))
                    }),
                    r("pointerUp", o),
                    t || i()
                },
                handleMouseWheel: function(t) {
                    if (Y <= m.currItem.fitRatio)
                        return g.modal && (!g.closeOnScroll || se || Et ? t.preventDefault() : st && 2 < Math.abs(t.deltaY) && (W = !0,
                        m.close())),
                        !0;
                    if (t.stopPropagation(),
                    Qe.x = 0,
                    "deltaX"in t)
                        1 === t.deltaMode ? (Qe.x = 18 * t.deltaX,
                        Qe.y = 18 * t.deltaY) : (Qe.x = t.deltaX,
                        Qe.y = t.deltaY);
                    else if ("wheelDelta"in t)
                        t.wheelDeltaX && (Qe.x = -.16 * t.wheelDeltaX),
                        t.wheelDeltaY ? Qe.y = -.16 * t.wheelDeltaY : Qe.y = -.16 * t.wheelDelta;
                    else {
                        if (!("detail"in t))
                            return;
                        Qe.y = t.detail
                    }
                    h(Y, !0);
                    var e = Ht.x - Qe.x
                      , i = Ht.y - Qe.y;
                    (g.modal || e <= Mt.min.x && e >= Mt.max.x && i <= Mt.min.y && i >= Mt.max.y) && t.preventDefault(),
                    m.panTo(e, i)
                },
                toggleDesktopZoom: function(t) {
                    t = t || {
                        x: qt.x / 2 + Zt.x,
                        y: qt.y / 2 + Zt.y
                    };
                    var e = g.getDoubleTapZoom(!0, m.currItem)
                      , i = Y === e;
                    m.mouseZoomedIn = !i,
                    m.zoomTo(i ? m.currItem.initialZoomLevel : e, t, 333),
                    f[(i ? "remove" : "add") + "Class"](p, "pswp--zoomed-in")
                }
            }
        }),
        f.extend(m, e)
    }
}),
function(t, e) {
    "function" == typeof define && define.amd ? define(e) : "object" == typeof exports ? module.exports = e() : t.PhotoSwipeUI_Default = e()
}(this, function() {
    "use strict";
    return function(n, a) {
        function t(t) {
            if (P)
                return !0;
            t = t || window.event,
            k.timeToIdle && k.mouseUsed && !x && N();
            for (var e, i, n = (t.target || t.srcElement).getAttribute("class") || "", o = 0; o < U.length; o++)
                (e = U[o]).onTap && -1 < n.indexOf("pswp__" + e.name) && (e.onTap(),
                i = !0);
            i && (t.stopPropagation && t.stopPropagation(),
            P = !0,
            t = a.features.isOldAndroid ? 600 : 30,
            setTimeout(function() {
                P = !1
            }, t))
        }
        function e(t, e, i) {
            a[(i ? "add" : "remove") + "Class"](t, "pswp__" + e)
        }
        function i() {
            var t = 1 === k.getNumItemsFn();
            t !== D && (e(p, "ui--one-slide", t),
            D = t)
        }
        function o() {
            e(y, "share-modal--hidden", z)
        }
        function r() {
            return (z = !z) ? (a.removeClass(y, "pswp__share-modal--fade-in"),
            setTimeout(function() {
                z && o()
            }, 300)) : (o(),
            setTimeout(function() {
                z || a.addClass(y, "pswp__share-modal--fade-in")
            }, 30)),
            z || O(),
            0
        }
        function s(t) {
            var e = (t = t || window.event).target || t.srcElement;
            return n.shout("shareLinkClick", t, e),
            !(!e.href || !e.hasAttribute("download") && (window.open(e.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)),
            z || r(),
            1))
        }
        function l(t) {
            for (var e = 0; e < k.closeElClasses.length; e++)
                if (a.hasClass(t, "pswp__" + k.closeElClasses[e]))
                    return !0
        }
        function c(t) {
            (t = (t = t || window.event).relatedTarget || t.toElement) && "HTML" !== t.nodeName || (clearTimeout(I),
            I = setTimeout(function() {
                A.setIdle(!0)
            }, k.timeToIdleOutside))
        }
        function u(t) {
            E !== t && (e(S, "preloader--active", !t),
            E = t)
        }
        function d(t) {
            var e, i = t.vGap;
            !n.likelyTouchDevice || k.mouseUsed || screen.width > k.fitControlsWidth ? (e = k.barsSize,
            k.captionEl && "auto" === e.bottom ? (m || ((m = a.createEl("pswp__caption pswp__caption--fake")).appendChild(a.createEl("pswp__caption__center")),
            p.insertBefore(m, f),
            a.addClass(p, "pswp__ui--fit")),
            k.addCaptionHTMLFn(t, m, !0) ? (t = m.clientHeight,
            i.bottom = parseInt(t, 10) || 44) : i.bottom = e.top) : i.bottom = "auto" === e.bottom ? 0 : e.bottom,
            i.top = e.top) : i.top = i.bottom = 0
        }
        var h, p, f, m, g, v, y, b, x, w, S, E, C, D, k, P, _, I, A = this, T = !1, M = !0, z = !0, L = {
            barsSize: {
                top: 44,
                bottom: "auto"
            },
            closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
            timeToIdle: 4e3,
            timeToIdleOutside: 1e3,
            loadingIndicatorDelay: 1e3,
            addCaptionHTMLFn: function(t, e) {
                return t.title ? (e.children[0].innerHTML = t.title,
                !0) : (e.children[0].innerHTML = "",
                !1)
            },
            closeEl: !0,
            captionEl: !0,
            fullscreenEl: !0,
            zoomEl: !0,
            shareEl: !0,
            counterEl: !0,
            arrowEl: !0,
            preloaderEl: !0,
            tapToClose: !1,
            tapToToggleControls: !0,
            clickToCloseNonZoomable: !0,
            shareButtons: [{
                id: "facebook",
                label: "Share on Facebook",
                url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
            }, {
                id: "twitter",
                label: "Tweet",
                url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
            }, {
                id: "pinterest",
                label: "Pin it",
                url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
            }, {
                id: "download",
                label: "Download image",
                url: "{{raw_image_url}}",
                download: !0
            }],
            getImageURLForShare: function() {
                return n.currItem.src || ""
            },
            getPageURLForShare: function() {
                return window.location.href
            },
            getTextForShare: function() {
                return n.currItem.title || ""
            },
            indexIndicatorSep: " / ",
            fitControlsWidth: 1200
        }, O = function() {
            for (var t, e, i, n, o = "", r = 0; r < k.shareButtons.length; r++)
                t = k.shareButtons[r],
                e = k.getImageURLForShare(t),
                i = k.getPageURLForShare(t),
                n = k.getTextForShare(t),
                o += '<a href="' + t.url.replace("{{url}}", encodeURIComponent(i)).replace("{{image_url}}", encodeURIComponent(e)).replace("{{raw_image_url}}", e).replace("{{text}}", encodeURIComponent(n)) + '" target="_blank" class="pswp__share--' + t.id + '"' + (t.download ? "download" : "") + ">" + t.label + "</a>",
                k.parseShareButtonOut && (o = k.parseShareButtonOut(t, o));
            y.children[0].innerHTML = o,
            y.children[0].onclick = s
        }, F = 0, N = function() {
            clearTimeout(I),
            F = 0,
            x && A.setIdle(!1)
        }, U = [{
            name: "caption",
            option: "captionEl",
            onInit: function(t) {
                f = t
            }
        }, {
            name: "share-modal",
            option: "shareEl",
            onInit: function(t) {
                y = t
            },
            onTap: function() {
                r()
            }
        }, {
            name: "button--share",
            option: "shareEl",
            onInit: function(t) {
                v = t
            },
            onTap: function() {
                r()
            }
        }, {
            name: "button--zoom",
            option: "zoomEl",
            onTap: n.toggleDesktopZoom
        }, {
            name: "counter",
            option: "counterEl",
            onInit: function(t) {
                g = t
            }
        }, {
            name: "button--close",
            option: "closeEl",
            onTap: n.close
        }, {
            name: "button--arrow--left",
            option: "arrowEl",
            onTap: n.prev
        }, {
            name: "button--arrow--right",
            option: "arrowEl",
            onTap: n.next
        }, {
            name: "button--fs",
            option: "fullscreenEl",
            onTap: function() {
                h.isFullscreen() ? h.exit() : h.enter()
            }
        }, {
            name: "preloader",
            option: "preloaderEl",
            onInit: function(t) {
                S = t
            }
        }];
        A.init = function() {
            var e;
            a.extend(n.options, L, !0),
            k = n.options,
            p = a.getChildByClass(n.scrollWrap, "pswp__ui"),
            (w = n.listen)("onVerticalDrag", function(t) {
                M && t < .95 ? A.hideControls() : !M && .95 <= t && A.showControls()
            }),
            w("onPinchClose", function(t) {
                M && t < .9 ? (A.hideControls(),
                e = !0) : e && !M && .9 < t && A.showControls()
            }),
            w("zoomGestureEnded", function() {
                e = !1
            }),
            w("beforeChange", A.update),
            w("doubleTap", function(t) {
                var e = n.currItem.initialZoomLevel;
                n.getZoomLevel() !== e ? n.zoomTo(e, t, 333) : n.zoomTo(k.getDoubleTapZoom(!1, n.currItem), t, 333)
            }),
            w("preventDragEvent", function(t, e, i) {
                var n = t.target || t.srcElement;
                n && n.getAttribute("class") && -1 < t.type.indexOf("mouse") && (0 < n.getAttribute("class").indexOf("__caption") || /(SMALL|STRONG|EM)/i.test(n.tagName)) && (i.prevent = !1)
            }),
            w("bindEvents", function() {
                a.bind(p, "pswpTap click", t),
                a.bind(n.scrollWrap, "pswpTap", A.onGlobalTap),
                n.likelyTouchDevice || a.bind(n.scrollWrap, "mouseover", A.onMouseOver)
            }),
            w("unbindEvents", function() {
                z || r(),
                _ && clearInterval(_),
                a.unbind(document, "mouseout", c),
                a.unbind(document, "mousemove", N),
                a.unbind(p, "pswpTap click", t),
                a.unbind(n.scrollWrap, "pswpTap", A.onGlobalTap),
                a.unbind(n.scrollWrap, "mouseover", A.onMouseOver),
                h && (a.unbind(document, h.eventK, A.updateFullscreen),
                h.isFullscreen() && (k.hideAnimationDuration = 0,
                h.exit()),
                h = null)
            }),
            w("destroy", function() {
                k.captionEl && (m && p.removeChild(m),
                a.removeClass(f, "pswp__caption--empty")),
                y && (y.children[0].onclick = null),
                a.removeClass(p, "pswp__ui--over-close"),
                a.addClass(p, "pswp__ui--hidden"),
                A.setIdle(!1)
            }),
            k.showAnimationDuration || a.removeClass(p, "pswp__ui--hidden"),
            w("initialZoomIn", function() {
                k.showAnimationDuration && a.removeClass(p, "pswp__ui--hidden")
            }),
            w("initialZoomOut", function() {
                a.addClass(p, "pswp__ui--hidden")
            }),
            w("parseVerticalMargin", d),
            function() {
                function t(t) {
                    if (t)
                        for (var e = t.length, i = 0; i < e; i++) {
                            o = t[i],
                            r = o.className;
                            for (var n = 0; n < U.length; n++)
                                s = U[n],
                                -1 < r.indexOf("pswp__" + s.name) && (k[s.option] ? (a.removeClass(o, "pswp__element--disabled"),
                                s.onInit && s.onInit(o)) : a.addClass(o, "pswp__element--disabled"))
                        }
                }
                var o, r, s;
                t(p.children);
                var e = a.getChildByClass(p, "pswp__top-bar");
                e && t(e.children)
            }(),
            k.shareEl && v && y && (z = !0),
            i(),
            k.timeToIdle && w("mouseUsed", function() {
                a.bind(document, "mousemove", N),
                a.bind(document, "mouseout", c),
                _ = setInterval(function() {
                    2 == ++F && A.setIdle(!0)
                }, k.timeToIdle / 2)
            }),
            k.fullscreenEl && !a.features.isOldAndroid && ((h = h || A.getFullscreenAPI()) ? (a.bind(document, h.eventK, A.updateFullscreen),
            A.updateFullscreen(),
            a.addClass(n.template, "pswp--supports-fs")) : a.removeClass(n.template, "pswp--supports-fs")),
            k.preloaderEl && (u(!0),
            w("beforeChange", function() {
                clearTimeout(C),
                C = setTimeout(function() {
                    n.currItem && n.currItem.loading ? n.allowProgressiveImg() && (!n.currItem.img || n.currItem.img.naturalWidth) || u(!1) : u(!0)
                }, k.loadingIndicatorDelay)
            }),
            w("imageLoadComplete", function(t, e) {
                n.currItem === e && u(!0)
            }))
        }
        ,
        A.setIdle = function(t) {
            e(p, "ui--idle", x = t)
        }
        ,
        A.update = function() {
            T = !(!M || !n.currItem) && (A.updateIndexIndicator(),
            k.captionEl && (k.addCaptionHTMLFn(n.currItem, f),
            e(f, "caption--empty", !n.currItem.title)),
            !0),
            z || r(),
            i()
        }
        ,
        A.updateFullscreen = function(t) {
            t && setTimeout(function() {
                n.setScrollOffset(0, a.getScrollY())
            }, 50),
            a[(h.isFullscreen() ? "add" : "remove") + "Class"](n.template, "pswp--fs")
        }
        ,
        A.updateIndexIndicator = function() {
            k.counterEl && (g.innerHTML = n.getCurrentIndex() + 1 + k.indexIndicatorSep + k.getNumItemsFn())
        }
        ,
        A.onGlobalTap = function(t) {
            var e = (t = t || window.event).target || t.srcElement;
            if (!P)
                if (t.detail && "mouse" === t.detail.pointerType)
                    l(e) ? n.close() : a.hasClass(e, "pswp__img") && (1 === n.getZoomLevel() && n.getZoomLevel() <= n.currItem.fitRatio ? k.clickToCloseNonZoomable && n.close() : n.toggleDesktopZoom(t.detail.releasePoint));
                else if (k.tapToToggleControls && (M ? A.hideControls() : A.showControls()),
                k.tapToClose && (a.hasClass(e, "pswp__img") || l(e)))
                    return void n.close()
        }
        ,
        A.onMouseOver = function(t) {
            t = (t = t || window.event).target || t.srcElement;
            e(p, "ui--over-close", l(t))
        }
        ,
        A.hideControls = function() {
            a.addClass(p, "pswp__ui--hidden"),
            M = !1
        }
        ,
        A.showControls = function() {
            M = !0,
            T || A.update(),
            a.removeClass(p, "pswp__ui--hidden")
        }
        ,
        A.supportsFullscreen = function() {
            var t = document;
            return !!(t.exitFullscreen || t.mozCancelFullScreen || t.webkitExitFullscreen || t.msExitFullscreen)
        }
        ,
        A.getFullscreenAPI = function() {
            var t, e = document.documentElement, i = "fullscreenchange";
            return e.requestFullscreen ? t = {
                enterK: "requestFullscreen",
                exitK: "exitFullscreen",
                elementK: "fullscreenElement",
                eventK: i
            } : e.mozRequestFullScreen ? t = {
                enterK: "mozRequestFullScreen",
                exitK: "mozCancelFullScreen",
                elementK: "mozFullScreenElement",
                eventK: "moz" + i
            } : e.webkitRequestFullscreen ? t = {
                enterK: "webkitRequestFullscreen",
                exitK: "webkitExitFullscreen",
                elementK: "webkitFullscreenElement",
                eventK: "webkit" + i
            } : e.msRequestFullscreen && (t = {
                enterK: "msRequestFullscreen",
                exitK: "msExitFullscreen",
                elementK: "msFullscreenElement",
                eventK: "MSFullscreenChange"
            }),
            t && (t.enter = function() {
                return b = k.closeOnScroll,
                k.closeOnScroll = !1,
                "webkitRequestFullscreen" !== this.enterK ? n.template[this.enterK]() : void n.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
            }
            ,
            t.exit = function() {
                return k.closeOnScroll = b,
                document[this.exitK]()
            }
            ,
            t.isFullscreen = function() {
                return document[this.elementK]
            }
            ),
            t
        }
    }
}),
function(t, e) {
    "object" == typeof exports && "undefined" != typeof module ? e(exports) : "function" == typeof define && define.amd ? define(["exports"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).noUiSlider = {})
}(this, function(et) {
    "use strict";
    function n(t) {
        return "object" == typeof t && "function" == typeof t.to
    }
    function it(t) {
        t.parentElement.removeChild(t)
    }
    function nt(t) {
        return null != t
    }
    function ot(t) {
        t.preventDefault()
    }
    function o(t) {
        return "number" == typeof t && !isNaN(t) && isFinite(t)
    }
    function rt(t, e, i) {
        0 < i && (lt(t, e),
        setTimeout(function() {
            ct(t, e)
        }, i))
    }
    function st(t) {
        return Math.max(Math.min(t, 100), 0)
    }
    function at(t) {
        return Array.isArray(t) ? t : [t]
    }
    function e(t) {
        t = (t = String(t)).split(".");
        return 1 < t.length ? t[1].length : 0
    }
    function lt(t, e) {
        t.classList && !/\s/.test(e) ? t.classList.add(e) : t.className += " " + e
    }
    function ct(t, e) {
        t.classList && !/\s/.test(e) ? t.classList.remove(e) : t.className = t.className.replace(new RegExp("(^|\\b)" + e.split(" ").join("|") + "(\\b|$)","gi"), " ")
    }
    function ut(t) {
        var e = void 0 !== window.pageXOffset
          , i = "CSS1Compat" === (t.compatMode || "");
        return {
            x: e ? window.pageXOffset : (i ? t.documentElement : t.body).scrollLeft,
            y: e ? window.pageYOffset : (i ? t.documentElement : t.body).scrollTop
        }
    }
    function s(t, e) {
        return 100 / (e - t)
    }
    function a(t, e, i) {
        return 100 * e / (t[i + 1] - t[i])
    }
    function l(t, e) {
        for (var i = 1; t >= e[i]; )
            i += 1;
        return i
    }
    et.PipsMode = void 0,
    (L = et.PipsMode || (et.PipsMode = {})).Range = "range",
    L.Steps = "steps",
    L.Positions = "positions",
    L.Count = "count",
    L.Values = "values",
    et.PipsType = void 0,
    (L = et.PipsType || (et.PipsType = {}))[L.None = -1] = "None",
    L[L.NoValue = 0] = "NoValue",
    L[L.LargeValue = 1] = "LargeValue",
    L[L.SmallValue = 2] = "SmallValue";
    var i = (t.prototype.getDistance = function(t) {
        for (var e = [], i = 0; i < this.xNumSteps.length - 1; i++) {
            var n = this.xNumSteps[i];
            if (n && t / n % 1 != 0)
                throw new Error("noUiSlider: 'limit', 'margin' and 'padding' of " + this.xPct[i] + "% range must be divisible by step.");
            e[i] = a(this.xVal, t, i)
        }
        return e
    }
    ,
    t.prototype.getAbsoluteDistance = function(t, e, i) {
        var n = 0;
        if (t < this.xPct[this.xPct.length - 1])
            for (; t > this.xPct[n + 1]; )
                n++;
        else
            t === this.xPct[this.xPct.length - 1] && (n = this.xPct.length - 2);
        i || t !== this.xPct[n + 1] || n++,
        null === e && (e = []);
        for (var o, r = 1, s = e[n], a = 0, l = 0, c = 0, u = i ? (t - this.xPct[n]) / (this.xPct[n + 1] - this.xPct[n]) : (this.xPct[n + 1] - t) / (this.xPct[n + 1] - this.xPct[n]); 0 < s; )
            o = this.xPct[n + 1 + c] - this.xPct[n + c],
            100 < e[n + c] * r + 100 - 100 * u ? (a = o * u,
            r = (s - 100 * u) / e[n + c],
            u = 1) : (a = e[n + c] * o / 100 * r,
            r = 0),
            i ? (l -= a,
            1 <= this.xPct.length + c && c--) : (l += a,
            1 <= this.xPct.length - c && c++),
            s = e[n + c] * r;
        return t + l
    }
    ,
    t.prototype.toStepping = function(t) {
        return function(t, e, i) {
            if (i >= t.slice(-1)[0])
                return 100;
            var n = l(i, t)
              , o = t[n - 1]
              , r = t[n]
              , t = e[n - 1]
              , n = e[n];
            return t + (i = i,
            a(r = [o, r], r[0] < 0 ? i + Math.abs(r[0]) : i - r[0], 0) / s(t, n))
        }(this.xVal, this.xPct, t)
    }
    ,
    t.prototype.fromStepping = function(t) {
        return function(t, e, i) {
            if (100 <= i)
                return t.slice(-1)[0];
            var n = l(i, e)
              , o = t[n - 1]
              , r = t[n]
              , t = e[n - 1];
            return r = [o, r],
            (i - t) * s(t, e[n]) * (r[1] - r[0]) / 100 + r[0]
        }(this.xVal, this.xPct, t)
    }
    ,
    t.prototype.getStep = function(t) {
        return function(t, e, i, n) {
            if (100 === n)
                return n;
            var o = l(n, t)
              , r = t[o - 1]
              , s = t[o];
            return i ? (s - r) / 2 < n - r ? s : r : e[o - 1] ? t[o - 1] + (t = n - t[o - 1],
            o = e[o - 1],
            Math.round(t / o) * o) : n
        }(this.xPct, this.xSteps, this.snap, t)
    }
    ,
    t.prototype.getDefaultStep = function(t, e, i) {
        var n = l(t, this.xPct);
        return (100 === t || e && t === this.xPct[n - 1]) && (n = Math.max(n - 1, 1)),
        (this.xVal[n] - this.xVal[n - 1]) / i
    }
    ,
    t.prototype.getNearbySteps = function(t) {
        t = l(t, this.xPct);
        return {
            stepBefore: {
                startValue: this.xVal[t - 2],
                step: this.xNumSteps[t - 2],
                highestStep: this.xHighestCompleteStep[t - 2]
            },
            thisStep: {
                startValue: this.xVal[t - 1],
                step: this.xNumSteps[t - 1],
                highestStep: this.xHighestCompleteStep[t - 1]
            },
            stepAfter: {
                startValue: this.xVal[t],
                step: this.xNumSteps[t],
                highestStep: this.xHighestCompleteStep[t]
            }
        }
    }
    ,
    t.prototype.countStepDecimals = function() {
        var t = this.xNumSteps.map(e);
        return Math.max.apply(null, t)
    }
    ,
    t.prototype.convert = function(t) {
        return this.getStep(this.toStepping(t))
    }
    ,
    t.prototype.handleEntryPoint = function(t, e) {
        if (!o(t = "min" === t ? 0 : "max" === t ? 100 : parseFloat(t)) || !o(e[0]))
            throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(t),
        this.xVal.push(e[0]);
        e = Number(e[1]);
        t ? this.xSteps.push(!isNaN(e) && e) : isNaN(e) || (this.xSteps[0] = e),
        this.xHighestCompleteStep.push(0)
    }
    ,
    t.prototype.handleStepPoint = function(t, e) {
        e && (this.xVal[t] !== this.xVal[t + 1] ? (this.xSteps[t] = a([this.xVal[t], this.xVal[t + 1]], e, 0) / s(this.xPct[t], this.xPct[t + 1]),
        e = (this.xVal[t + 1] - this.xVal[t]) / this.xNumSteps[t],
        e = Math.ceil(Number(e.toFixed(3)) - 1),
        e = this.xVal[t] + this.xNumSteps[t] * e,
        this.xHighestCompleteStep[t] = e) : this.xSteps[t] = this.xHighestCompleteStep[t] = this.xVal[t])
    }
    ,
    t)
      , c = {
        to: function(t) {
            return void 0 === t ? "" : t.toFixed(2)
        },
        from: Number
    }
      , u = {
        target: "target",
        base: "base",
        origin: "origin",
        handle: "handle",
        handleLower: "handle-lower",
        handleUpper: "handle-upper",
        touchArea: "touch-area",
        horizontal: "horizontal",
        vertical: "vertical",
        background: "background",
        connect: "connect",
        connects: "connects",
        ltr: "ltr",
        rtl: "rtl",
        textDirectionLtr: "txt-dir-ltr",
        textDirectionRtl: "txt-dir-rtl",
        draggable: "draggable",
        drag: "state-drag",
        tap: "state-tap",
        active: "active",
        tooltip: "tooltip",
        pips: "pips",
        pipsHorizontal: "pips-horizontal",
        pipsVertical: "pips-vertical",
        marker: "marker",
        markerHorizontal: "marker-horizontal",
        markerVertical: "marker-vertical",
        markerNormal: "marker-normal",
        markerLarge: "marker-large",
        markerSub: "marker-sub",
        value: "value",
        valueHorizontal: "value-horizontal",
        valueVertical: "value-vertical",
        valueNormal: "value-normal",
        valueLarge: "value-large",
        valueSub: "value-sub"
    }
      , dt = {
        tooltips: ".__tooltips",
        aria: ".__aria"
    };
    function t(e, t, i) {
        var n;
        this.xPct = [],
        this.xVal = [],
        this.xSteps = [],
        this.xNumSteps = [],
        this.xHighestCompleteStep = [],
        this.xSteps = [i || !1],
        this.xNumSteps = [!1],
        this.snap = t;
        var o = [];
        for (Object.keys(e).forEach(function(t) {
            o.push([at(e[t]), t])
        }),
        o.sort(function(t, e) {
            return t[0][0] - e[0][0]
        }),
        n = 0; n < o.length; n++)
            this.handleEntryPoint(o[n][1], o[n][0]);
        for (this.xNumSteps = this.xSteps.slice(0),
        n = 0; n < this.xNumSteps.length; n++)
            this.handleStepPoint(n, this.xNumSteps[n])
    }
    function d(t, e) {
        if (!o(e))
            throw new Error("noUiSlider: 'step' is not numeric.");
        t.singleStep = e
    }
    function h(t, e) {
        if (!o(e))
            throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
        t.keyboardPageMultiplier = e
    }
    function p(t, e) {
        if (!o(e))
            throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
        t.keyboardDefaultStep = e
    }
    function f(t, e) {
        if ("object" != typeof e || Array.isArray(e))
            throw new Error("noUiSlider: 'range' is not an object.");
        if (void 0 === e.min || void 0 === e.max)
            throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
        if (e.min === e.max)
            throw new Error("noUiSlider: 'range' 'min' and 'max' cannot be equal.");
        t.spectrum = new i(e,t.snap || !1,t.singleStep)
    }
    function m(t, e) {
        if (e = at(e),
        !Array.isArray(e) || !e.length)
            throw new Error("noUiSlider: 'start' option is incorrect.");
        t.handles = e.length,
        t.start = e
    }
    function g(t, e) {
        if ("boolean" != typeof e)
            throw new Error("noUiSlider: 'snap' option must be a boolean.");
        t.snap = e
    }
    function v(t, e) {
        if ("boolean" != typeof e)
            throw new Error("noUiSlider: 'animate' option must be a boolean.");
        t.animate = e
    }
    function y(t, e) {
        if ("number" != typeof e)
            throw new Error("noUiSlider: 'animationDuration' option must be a number.");
        t.animationDuration = e
    }
    function b(t, e) {
        var i, n = [!1];
        if ("lower" === e ? e = [!0, !1] : "upper" === e && (e = [!1, !0]),
        !0 === e || !1 === e) {
            for (i = 1; i < t.handles; i++)
                n.push(e);
            n.push(!1)
        } else {
            if (!Array.isArray(e) || !e.length || e.length !== t.handles + 1)
                throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
            n = e
        }
        t.connect = n
    }
    function x(t, e) {
        switch (e) {
        case "horizontal":
            t.ort = 0;
            break;
        case "vertical":
            t.ort = 1;
            break;
        default:
            throw new Error("noUiSlider: 'orientation' option is invalid.")
        }
    }
    function w(t, e) {
        if (!o(e))
            throw new Error("noUiSlider: 'margin' option must be numeric.");
        0 !== e && (t.margin = t.spectrum.getDistance(e))
    }
    function S(t, e) {
        if (!o(e))
            throw new Error("noUiSlider: 'limit' option must be numeric.");
        if (t.limit = t.spectrum.getDistance(e),
        !t.limit || t.handles < 2)
            throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.")
    }
    function E(t, e) {
        var i;
        if (!o(e) && !Array.isArray(e))
            throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
        if (Array.isArray(e) && 2 !== e.length && !o(e[0]) && !o(e[1]))
            throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
        if (0 !== e) {
            for (Array.isArray(e) || (e = [e, e]),
            t.padding = [t.spectrum.getDistance(e[0]), t.spectrum.getDistance(e[1])],
            i = 0; i < t.spectrum.xNumSteps.length - 1; i++)
                if (t.padding[0][i] < 0 || t.padding[1][i] < 0)
                    throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
            var n = e[0] + e[1]
              , e = t.spectrum.xVal[0];
            if (1 < n / (t.spectrum.xVal[t.spectrum.xVal.length - 1] - e))
                throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.")
        }
    }
    function C(t, e) {
        switch (e) {
        case "ltr":
            t.dir = 0;
            break;
        case "rtl":
            t.dir = 1;
            break;
        default:
            throw new Error("noUiSlider: 'direction' option was not recognized.")
        }
    }
    function D(t, e) {
        if ("string" != typeof e)
            throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
        var i = 0 <= e.indexOf("tap")
          , n = 0 <= e.indexOf("drag")
          , o = 0 <= e.indexOf("fixed")
          , r = 0 <= e.indexOf("snap")
          , s = 0 <= e.indexOf("hover")
          , e = 0 <= e.indexOf("unconstrained");
        if (o) {
            if (2 !== t.handles)
                throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
            w(t, t.start[1] - t.start[0])
        }
        if (e && (t.margin || t.limit))
            throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
        t.events = {
            tap: i || r,
            drag: n,
            fixed: o,
            snap: r,
            hover: s,
            unconstrained: e
        }
    }
    function k(t, e) {
        if (!1 !== e)
            if (!0 === e || n(e)) {
                t.tooltips = [];
                for (var i = 0; i < t.handles; i++)
                    t.tooltips.push(e)
            } else {
                if ((e = at(e)).length !== t.handles)
                    throw new Error("noUiSlider: must pass a formatter for all handles.");
                e.forEach(function(t) {
                    if ("boolean" != typeof t && !n(t))
                        throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.")
                }),
                t.tooltips = e
            }
    }
    function P(t, e) {
        if (!n(e))
            throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
        t.ariaFormat = e
    }
    function _(t, e) {
        if (!n(e) || "function" != typeof e.from)
            throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
        t.format = e
    }
    function I(t, e) {
        if ("boolean" != typeof e)
            throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
        t.keyboardSupport = e
    }
    function A(t, e) {
        t.documentElement = e
    }
    function T(t, e) {
        if ("string" != typeof e && !1 !== e)
            throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
        t.cssPrefix = e
    }
    function M(e, i) {
        if ("object" != typeof i)
            throw new Error("noUiSlider: 'cssClasses' must be an object.");
        "string" == typeof e.cssPrefix ? (e.cssClasses = {},
        Object.keys(i).forEach(function(t) {
            e.cssClasses[t] = e.cssPrefix + i[t]
        })) : e.cssClasses = i
    }
    function ht(e) {
        var i = {
            margin: null,
            limit: null,
            padding: null,
            animate: !0,
            animationDuration: 300,
            ariaFormat: c,
            format: c
        }
          , n = {
            step: {
                r: !1,
                t: d
            },
            keyboardPageMultiplier: {
                r: !1,
                t: h
            },
            keyboardDefaultStep: {
                r: !1,
                t: p
            },
            start: {
                r: !0,
                t: m
            },
            connect: {
                r: !0,
                t: b
            },
            direction: {
                r: !0,
                t: C
            },
            snap: {
                r: !1,
                t: g
            },
            animate: {
                r: !1,
                t: v
            },
            animationDuration: {
                r: !1,
                t: y
            },
            range: {
                r: !0,
                t: f
            },
            orientation: {
                r: !1,
                t: x
            },
            margin: {
                r: !1,
                t: w
            },
            limit: {
                r: !1,
                t: S
            },
            padding: {
                r: !1,
                t: E
            },
            behaviour: {
                r: !0,
                t: D
            },
            ariaFormat: {
                r: !1,
                t: P
            },
            format: {
                r: !1,
                t: _
            },
            tooltips: {
                r: !1,
                t: k
            },
            keyboardSupport: {
                r: !0,
                t: I
            },
            documentElement: {
                r: !1,
                t: A
            },
            cssPrefix: {
                r: !0,
                t: T
            },
            cssClasses: {
                r: !0,
                t: M
            }
        }
          , o = {
            connect: !1,
            direction: "ltr",
            behaviour: "tap",
            orientation: "horizontal",
            keyboardSupport: !0,
            cssPrefix: "noUi-",
            cssClasses: u,
            keyboardPageMultiplier: 5,
            keyboardDefaultStep: 10
        };
        e.format && !e.ariaFormat && (e.ariaFormat = e.format),
        Object.keys(n).forEach(function(t) {
            if (nt(e[t]) || void 0 !== o[t])
                n[t].t(i, (nt(e[t]) ? e : o)[t]);
            else if (n[t].r)
                throw new Error("noUiSlider: '" + t + "' is required.")
        }),
        i.pips = e.pips;
        var t = document.createElement("div")
          , r = void 0 !== t.style.msTransform
          , t = void 0 !== t.style.transform;
        return i.transformRule = t ? "transform" : r ? "msTransform" : "webkitTransform",
        i.style = [["left", "top"], ["right", "bottom"]][i.dir][i.ort],
        i
    }
    function r(t, p, r) {
        var o, a, s, n, l, c, u = window.navigator.pointerEnabled ? {
            start: "pointerdown",
            move: "pointermove",
            end: "pointerup"
        } : window.navigator.msPointerEnabled ? {
            start: "MSPointerDown",
            move: "MSPointerMove",
            end: "MSPointerUp"
        } : {
            start: "mousedown touchstart",
            move: "mousemove touchmove",
            end: "mouseup touchend"
        }, d = window.CSS && CSS.supports && CSS.supports("touch-action", "none") && function() {
            var t = !1;
            try {
                var e = Object.defineProperty({}, "passive", {
                    get: function() {
                        t = !0
                    }
                });
                window.addEventListener("test", null, e)
            } catch (t) {}
            return t
        }(), h = t, b = p.spectrum, f = [], m = [], g = [], v = 0, y = {}, x = t.ownerDocument, w = p.documentElement || x.documentElement, S = x.body, E = "rtl" === x.dir || 1 === p.ort ? 0 : 100;
        function C(t, e) {
            var i = x.createElement("div");
            return e && lt(i, e),
            t.appendChild(i),
            i
        }
        function D(t, e) {
            return !!e && C(t, p.cssClasses.connect)
        }
        function e(t, e) {
            return !(!p.tooltips || !p.tooltips[e]) && C(t.firstChild, p.cssClasses.tooltip)
        }
        function k() {
            return h.hasAttribute("disabled")
        }
        function P(t) {
            return a[t].hasAttribute("disabled")
        }
        function _() {
            l && (W("update" + dt.tooltips),
            l.forEach(function(t) {
                t && it(t)
            }),
            l = null)
        }
        function I() {
            _(),
            l = a.map(e),
            i("update" + dt.tooltips, function(t, e, i) {
                l && p.tooltips && !1 !== l[e] && (t = t[e],
                !0 !== p.tooltips[e] && (t = p.tooltips[e].to(i[e])),
                l[e].innerHTML = t)
            })
        }
        function A(t, e) {
            return t.map(function(t) {
                return b.fromStepping(e ? b.getStep(t) : t)
            })
        }
        function T(o, r, s) {
            var t, a = x.createElement("div"), l = ((t = {})[et.PipsType.None] = "",
            t[et.PipsType.NoValue] = p.cssClasses.valueNormal,
            t[et.PipsType.LargeValue] = p.cssClasses.valueLarge,
            t[et.PipsType.SmallValue] = p.cssClasses.valueSub,
            t), c = ((t = {})[et.PipsType.None] = "",
            t[et.PipsType.NoValue] = p.cssClasses.markerNormal,
            t[et.PipsType.LargeValue] = p.cssClasses.markerLarge,
            t[et.PipsType.SmallValue] = p.cssClasses.markerSub,
            t), u = [p.cssClasses.valueHorizontal, p.cssClasses.valueVertical], d = [p.cssClasses.markerHorizontal, p.cssClasses.markerVertical];
            function h(t, e) {
                var i = e === p.cssClasses.value
                  , n = i ? l : c;
                return e + " " + (i ? u : d)[p.ort] + " " + n[t]
            }
            return lt(a, p.cssClasses.pips),
            lt(a, 0 === p.ort ? p.cssClasses.pipsHorizontal : p.cssClasses.pipsVertical),
            Object.keys(o).forEach(function(t) {
                var e, i, n;
                i = o[e = t][0],
                n = o[t][1],
                (n = r ? r(i, n) : n) !== et.PipsType.None && ((t = C(a, !1)).className = h(n, p.cssClasses.marker),
                t.style[p.style] = e + "%",
                n > et.PipsType.NoValue && ((t = C(a, !1)).className = h(n, p.cssClasses.value),
                t.setAttribute("data-value", String(i)),
                t.style[p.style] = e + "%",
                t.innerHTML = String(s.to(i))))
            }),
            a
        }
        function M() {
            n && (it(n),
            n = null)
        }
        function z(t) {
            M();
            var p, f, m, e, i, g, v, y, e = (f = function(t) {
                if (t.mode === et.PipsMode.Range || t.mode === et.PipsMode.Steps)
                    return b.xVal;
                if (t.mode !== et.PipsMode.Count)
                    return t.mode === et.PipsMode.Positions ? A(t.values, t.stepped) : t.mode === et.PipsMode.Values ? t.stepped ? t.values.map(function(t) {
                        return b.fromStepping(b.getStep(b.toStepping(t)))
                    }) : t.values : [];
                if (t.values < 2)
                    throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
                for (var e = t.values - 1, i = 100 / e, n = []; e--; )
                    n[e] = e * i;
                return n.push(100),
                A(n, t.stepped)
            }(p = t),
            m = {},
            e = b.xVal[0],
            i = b.xVal[b.xVal.length - 1],
            v = g = !1,
            y = 0,
            (f = f.slice().sort(function(t, e) {
                return t - e
            }).filter(function(t) {
                return !this[t] && (this[t] = !0)
            }, {}))[0] !== e && (f.unshift(e),
            g = !0),
            f[f.length - 1] !== i && (f.push(i),
            v = !0),
            f.forEach(function(t, e) {
                var i, n, o, r, s, a, l, c, u, t = t, d = f[e + 1], h = p.mode === et.PipsMode.Steps;
                for (h && (i = b.xNumSteps[e]),
                i = i || d - t,
                void 0 === d && (d = t),
                i = Math.max(i, 1e-7),
                n = t; n <= d; n = Number((n + i).toFixed(7))) {
                    for (l = (s = (r = b.toStepping(n)) - y) / (p.density || 1),
                    u = s / (c = Math.round(l)),
                    o = 1; o <= c; o += 1)
                        m[(a = y + o * u).toFixed(5)] = [b.fromStepping(a), 0];
                    l = -1 < f.indexOf(n) ? et.PipsType.LargeValue : h ? et.PipsType.SmallValue : et.PipsType.NoValue,
                    !e && g && n !== d && (l = 0),
                    n === d && v || (m[r.toFixed(5)] = [n, l]),
                    y = r
                }
            }),
            m), i = t.filter, t = t.format || {
                to: function(t) {
                    return String(Math.round(t))
                }
            };
            return n = h.appendChild(T(e, i, t))
        }
        function L() {
            var t = o.getBoundingClientRect()
              , e = "offset" + ["Width", "Height"][p.ort];
            return 0 === p.ort ? t.width || o[e] : t.height || o[e]
        }
        function O(n, o, r, s) {
            function e(t) {
                var e, i = function(e, t, i) {
                    var n = 0 === e.type.indexOf("touch")
                      , o = 0 === e.type.indexOf("mouse")
                      , r = 0 === e.type.indexOf("pointer")
                      , s = 0
                      , a = 0;
                    if (0 === e.type.indexOf("MSPointer") && (r = !0),
                    "mousedown" === e.type && !e.buttons && !e.touches)
                        return !1;
                    if (n) {
                        var l = function(t) {
                            t = t.target;
                            return t === i || i.contains(t) || e.composed && e.composedPath().shift() === i
                        };
                        if ("touchstart" === e.type) {
                            n = Array.prototype.filter.call(e.touches, l);
                            if (1 < n.length)
                                return !1;
                            s = n[0].pageX,
                            a = n[0].pageY
                        } else {
                            l = Array.prototype.find.call(e.changedTouches, l);
                            if (!l)
                                return !1;
                            s = l.pageX,
                            a = l.pageY
                        }
                    }
                    return t = t || ut(x),
                    (o || r) && (s = e.clientX + t.x,
                    a = e.clientY + t.y),
                    e.pageOffset = t,
                    e.points = [s, a],
                    e.cursor = o || r,
                    e
                }(t, s.pageOffset, s.target || o);
                return !!i && !(k() && !s.doNotReject) && (e = h,
                t = p.cssClasses.tap,
                !((e.classList ? e.classList.contains(t) : new RegExp("\\b" + t + "\\b").test(e.className)) && !s.doNotReject) && !(n === u.start && void 0 !== i.buttons && 1 < i.buttons) && (!s.hover || !i.buttons) && (d || i.preventDefault(),
                i.calcPoint = i.points[p.ort],
                void r(i, s)))
            }
            var i = [];
            return n.split(" ").forEach(function(t) {
                o.addEventListener(t, e, !!d && {
                    passive: !0
                }),
                i.push([t, e])
            }),
            i
        }
        function F(t) {
            var e, i, n = st(n = 100 * (t - (n = o,
            e = p.ort,
            i = n.getBoundingClientRect(),
            n = (t = n.ownerDocument).documentElement,
            t = ut(t),
            /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (t.x = 0),
            e ? i.top + t.y - n.clientTop : i.left + t.x - n.clientLeft)) / L());
            return p.dir ? 100 - n : n
        }
        function N(t, e) {
            "mouseout" === t.type && "HTML" === t.target.nodeName && null === t.relatedTarget && R(t, e)
        }
        function U(t, e) {
            if (-1 === navigator.appVersion.indexOf("MSIE 9") && 0 === t.buttons && 0 !== e.buttonsProperty)
                return R(t, e);
            t = (p.dir ? -1 : 1) * (t.calcPoint - e.startCalcPoint);
            B(0 < t, 100 * t / e.baseSize, e.locations, e.handleNumbers, e.connect)
        }
        function R(t, e) {
            e.handle && (ct(e.handle, p.cssClasses.active),
            --v),
            e.listeners.forEach(function(t) {
                w.removeEventListener(t[0], t[1])
            }),
            0 === v && (ct(h, p.cssClasses.drag),
            X(),
            t.cursor && (S.style.cursor = "",
            S.removeEventListener("selectstart", ot))),
            e.handleNumbers.forEach(function(t) {
                V("change", t),
                V("set", t),
                V("end", t)
            })
        }
        function j(t, e) {
            var i, n, o, r;
            e.handleNumbers.some(P) || (1 === e.handleNumbers.length && (r = a[e.handleNumbers[0]].children[0],
            v += 1,
            lt(r, p.cssClasses.active)),
            t.stopPropagation(),
            i = [],
            n = O(u.move, w, U, {
                target: t.target,
                handle: r,
                connect: e.connect,
                listeners: i,
                startCalcPoint: t.calcPoint,
                baseSize: L(),
                pageOffset: t.pageOffset,
                handleNumbers: e.handleNumbers,
                buttonsProperty: t.buttons,
                locations: m.slice()
            }),
            o = O(u.end, w, R, {
                target: t.target,
                handle: r,
                listeners: i,
                doNotReject: !0,
                handleNumbers: e.handleNumbers
            }),
            r = O("mouseout", w, N, {
                target: t.target,
                handle: r,
                listeners: i,
                doNotReject: !0,
                handleNumbers: e.handleNumbers
            }),
            i.push.apply(i, n.concat(o, r)),
            t.cursor && (S.style.cursor = getComputedStyle(t.target).cursor,
            1 < a.length && lt(h, p.cssClasses.drag),
            S.addEventListener("selectstart", ot, !1)),
            e.handleNumbers.forEach(function(t) {
                V("start", t)
            }))
        }
        function i(t, e) {
            y[t] = y[t] || [],
            y[t].push(e),
            "update" === t.split(".")[0] && a.forEach(function(t, e) {
                V("update", e)
            })
        }
        function W(t) {
            var n = t && t.split(".")[0]
              , o = n ? t.substring(n.length) : t;
            Object.keys(y).forEach(function(t) {
                var e = t.split(".")[0]
                  , i = t.substring(e.length);
                n && n !== e || o && o !== i || (i === dt.aria || i === dt.tooltips) && o !== i || delete y[t]
            })
        }
        function V(i, n, o) {
            Object.keys(y).forEach(function(t) {
                var e = t.split(".")[0];
                i === e && y[t].forEach(function(t) {
                    t.call(tt, f.map(p.format.to), n, f.slice(), o || !1, m.slice(), tt)
                })
            })
        }
        function H(t, e, i, n, o, r) {
            var s;
            return 1 < a.length && !p.events.unconstrained && (n && 0 < e && (s = b.getAbsoluteDistance(t[e - 1], p.margin, !1),
            i = Math.max(i, s)),
            o && e < a.length - 1 && (s = b.getAbsoluteDistance(t[e + 1], p.margin, !0),
            i = Math.min(i, s))),
            1 < a.length && p.limit && (n && 0 < e && (s = b.getAbsoluteDistance(t[e - 1], p.limit, !1),
            i = Math.min(i, s)),
            o && e < a.length - 1 && (s = b.getAbsoluteDistance(t[e + 1], p.limit, !0),
            i = Math.max(i, s))),
            p.padding && (0 === e && (s = b.getAbsoluteDistance(0, p.padding[0], !1),
            i = Math.max(i, s)),
            e === a.length - 1 && (s = b.getAbsoluteDistance(100, p.padding[1], !0),
            i = Math.min(i, s))),
            !((i = st(i = b.getStep(i))) === t[e] && !r) && i
        }
        function q(t, e) {
            var i = p.ort;
            return (i ? e : t) + ", " + (i ? t : e)
        }
        function B(t, i, n, e, o) {
            var r = n.slice()
              , s = e[0]
              , a = [!t, t]
              , l = [t, !t];
            e = e.slice(),
            t && e.reverse(),
            1 < e.length ? e.forEach(function(t, e) {
                e = H(r, t, r[t] + i, a[e], l[e], !1);
                !1 === e ? i = 0 : (i = e - r[t],
                r[t] = e)
            }) : a = l = [!0];
            var c = !1;
            e.forEach(function(t, e) {
                c = Y(t, n[t] + i, a[e], l[e]) || c
            }),
            c && (e.forEach(function(t) {
                V("update", t),
                V("slide", t)
            }),
            null != o && V("drag", s))
        }
        function Z(t, e) {
            return p.dir ? 100 - t - e : t
        }
        function X() {
            g.forEach(function(t) {
                var e = 50 < m[t] ? -1 : 1
                  , e = 3 + (a.length + e * t);
                a[t].style.zIndex = String(e)
            })
        }
        function Y(t, e, i, n, o) {
            return o || (e = H(m, t, e, i, n, !1)),
            !1 !== e && (function(t, e) {
                m[t] = e,
                f[t] = b.fromStepping(e);
                e = "translate(" + q(10 * (Z(e, 0) - E) + "%", "0") + ")";
                a[t].style[p.transformRule] = e,
                G(t),
                G(t + 1)
            }(t, e),
            !0)
        }
        function G(t) {
            var e, i;
            s[t] && (i = 100,
            (e = 0) !== t && (e = m[t - 1]),
            t !== s.length - 1 && (i = m[t]),
            e = "translate(" + q(Z(e, i = i - e) + "%", "0") + ")",
            i = "scale(" + q(i / 100, "1") + ")",
            s[t].style[p.transformRule] = e + " " + i)
        }
        function K(t, e) {
            return null === t || !1 === t || void 0 === t ? m[e] : ("number" == typeof t && (t = String(t)),
            !1 !== (t = p.format.from(t)) && (t = b.toStepping(t)),
            !1 === t || isNaN(t) ? m[e] : t)
        }
        function $(t, e, i) {
            var n = at(t)
              , t = void 0 === m[0];
            e = void 0 === e || e,
            p.animate && !t && rt(h, p.cssClasses.tap, p.animationDuration),
            g.forEach(function(t) {
                Y(t, K(n[t], t), !0, !1, i)
            });
            for (var o = 1 === g.length ? 0 : 1; o < g.length; ++o)
                g.forEach(function(t) {
                    Y(t, m[t], !0, !0, i)
                });
            X(),
            g.forEach(function(t) {
                V("update", t),
                null !== n[t] && e && V("set", t)
            })
        }
        function J(t) {
            if (void 0 === t && (t = !1),
            t)
                return 1 === f.length ? f[0] : f.slice(0);
            t = f.map(p.format.to);
            return 1 === t.length ? t[0] : t
        }
        function Q(t) {
            var e = m[t]
              , i = b.getNearbySteps(e)
              , n = f[t]
              , o = i.thisStep.step
              , t = null;
            if (p.snap)
                return [n - i.stepBefore.startValue || null, i.stepAfter.startValue - n || null];
            !1 !== o && n + o > i.stepAfter.startValue && (o = i.stepAfter.startValue - n),
            t = n > i.thisStep.startValue ? i.thisStep.step : !1 !== i.stepBefore.step && n - i.stepBefore.highestStep,
            100 === e ? o = null : 0 === e && (t = null);
            e = b.countStepDecimals();
            return null !== o && !1 !== o && (o = Number(o.toFixed(e))),
            null !== t && !1 !== t && (t = Number(t.toFixed(e))),
            [t, o]
        }
        lt(t = h, p.cssClasses.target),
        0 === p.dir ? lt(t, p.cssClasses.ltr) : lt(t, p.cssClasses.rtl),
        0 === p.ort ? lt(t, p.cssClasses.horizontal) : lt(t, p.cssClasses.vertical),
        lt(t, "rtl" === getComputedStyle(t).direction ? p.cssClasses.textDirectionRtl : p.cssClasses.textDirectionLtr),
        o = C(t, p.cssClasses.base),
        function(t, e) {
            var i = C(e, p.cssClasses.connects);
            a = [],
            (s = []).push(D(i, t[0]));
            for (var n = 0; n < p.handles; n++)
                a.push(function(t, e) {
                    var i = C(t, p.cssClasses.origin)
                      , t = C(i, p.cssClasses.handle);
                    return C(t, p.cssClasses.touchArea),
                    t.setAttribute("data-handle", String(e)),
                    p.keyboardSupport && (t.setAttribute("tabindex", "0"),
                    t.addEventListener("keydown", function(t) {
                        return function(t, e) {
                            if (k() || P(e))
                                return !1;
                            var i = ["Left", "Right"]
                              , n = ["Down", "Up"]
                              , o = ["PageDown", "PageUp"]
                              , r = ["Home", "End"];
                            p.dir && !p.ort ? i.reverse() : p.ort && !p.dir && (n.reverse(),
                            o.reverse());
                            var s = t.key.replace("Arrow", "")
                              , a = s === o[0]
                              , l = s === o[1]
                              , o = s === n[0] || s === i[0] || a
                              , n = s === n[1] || s === i[1] || l
                              , i = s === r[1];
                            if (!(o || n || s === r[0] || i))
                                return !0;
                            if (t.preventDefault(),
                            n || o) {
                                var n = p.keyboardPageMultiplier
                                  , c = o ? 0 : 1
                                  , c = Q(e)[c];
                                if (null === c)
                                    return !1;
                                !1 === c && (c = b.getDefaultStep(m[e], o, p.keyboardDefaultStep)),
                                (l || a) && (c *= n),
                                c = Math.max(c, 1e-7),
                                c *= o ? -1 : 1,
                                c = f[e] + c
                            } else
                                c = i ? p.spectrum.xVal[p.spectrum.xVal.length - 1] : p.spectrum.xVal[0];
                            return Y(e, b.toStepping(c), !0, !0),
                            V("slide", e),
                            V("update", e),
                            V("change", e),
                            V("set", e),
                            !1
                        }(t, e)
                    })),
                    t.setAttribute("role", "slider"),
                    t.setAttribute("aria-orientation", p.ort ? "vertical" : "horizontal"),
                    0 === e ? lt(t, p.cssClasses.handleLower) : e === p.handles - 1 && lt(t, p.cssClasses.handleUpper),
                    i
                }(e, n)),
                g[n] = n,
                s.push(D(i, t[n + 1]))
        }(p.connect, o),
        (c = p.events).fixed || a.forEach(function(t, e) {
            O(u.start, t.children[0], j, {
                handleNumbers: [e]
            })
        }),
        c.tap && O(u.start, o, function(t) {
            t.stopPropagation();
            var o, r, s, e = F(t.calcPoint), i = (o = e,
            s = !(r = 100),
            a.forEach(function(t, e) {
                var i, n;
                P(e) || (i = m[e],
                ((n = Math.abs(i - o)) < r || n <= r && i < o || 100 === n && 100 === r) && (s = e,
                r = n))
            }),
            s);
            !1 !== i && (p.events.snap || rt(h, p.cssClasses.tap, p.animationDuration),
            Y(i, e, !0, !0),
            X(),
            V("slide", i, !0),
            V("update", i, !0),
            V("change", i, !0),
            V("set", i, !0),
            p.events.snap && j(t, {
                handleNumbers: [i]
            }))
        }, {}),
        c.hover && O(u.move, o, function(t) {
            var t = F(t.calcPoint)
              , t = b.getStep(t)
              , e = b.fromStepping(t);
            Object.keys(y).forEach(function(t) {
                "hover" === t.split(".")[0] && y[t].forEach(function(t) {
                    t.call(tt, e)
                })
            })
        }, {
            hover: !0
        }),
        c.drag && s.forEach(function(e, i) {
            var n, o, t;
            !1 !== e && 0 !== i && i !== s.length - 1 && (n = a[i - 1],
            o = a[i],
            t = [e],
            lt(e, p.cssClasses.draggable),
            c.fixed && (t.push(n.children[0]),
            t.push(o.children[0])),
            t.forEach(function(t) {
                O(u.start, t, j, {
                    handles: [n, o],
                    handleNumbers: [i - 1, i],
                    connect: e
                })
            }))
        }),
        $(p.start),
        p.pips && z(p.pips),
        p.tooltips && I(),
        W("update" + dt.aria),
        i("update" + dt.aria, function(t, e, r, i, s) {
            g.forEach(function(t) {
                var e = a[t]
                  , i = H(m, t, 0, !0, !0, !0)
                  , n = H(m, t, 100, !0, !0, !0)
                  , o = s[t]
                  , t = String(p.ariaFormat.to(r[t]))
                  , i = b.fromStepping(i).toFixed(1)
                  , n = b.fromStepping(n).toFixed(1)
                  , o = b.fromStepping(o).toFixed(1);
                e.children[0].setAttribute("aria-valuemin", i),
                e.children[0].setAttribute("aria-valuemax", n),
                e.children[0].setAttribute("aria-valuenow", o),
                e.children[0].setAttribute("aria-valuetext", t)
            })
        });
        var tt = {
            destroy: function() {
                for (W(dt.aria),
                W(dt.tooltips),
                Object.keys(p.cssClasses).forEach(function(t) {
                    ct(h, p.cssClasses[t])
                }); h.firstChild; )
                    h.removeChild(h.firstChild);
                delete h.noUiSlider
            },
            steps: function() {
                return g.map(Q)
            },
            on: i,
            off: W,
            get: J,
            set: $,
            setHandle: function(t, e, i, n) {
                if (!(0 <= (t = Number(t)) && t < g.length))
                    throw new Error("noUiSlider: invalid handle number, got: " + t);
                Y(t, K(e, t), !0, !0, n),
                V("update", t),
                i && V("set", t)
            },
            reset: function(t) {
                $(p.start, t)
            },
            __moveHandles: function(t, e, i) {
                B(t, e, m, i)
            },
            options: r,
            updateOptions: function(e, t) {
                var i = J()
                  , n = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
                n.forEach(function(t) {
                    void 0 !== e[t] && (r[t] = e[t])
                });
                var o = ht(r);
                n.forEach(function(t) {
                    void 0 !== e[t] && (p[t] = o[t])
                }),
                b = o.spectrum,
                p.margin = o.margin,
                p.limit = o.limit,
                p.padding = o.padding,
                p.pips ? z(p.pips) : M(),
                (p.tooltips ? I : _)(),
                m = [],
                $(nt(e.start) ? e.start : i, t)
            },
            target: h,
            removePips: M,
            removeTooltips: _,
            getTooltips: function() {
                return l
            },
            getOrigins: function() {
                return a
            },
            pips: z
        };
        return tt
    }
    function z(t, e) {
        if (!t || !t.nodeName)
            throw new Error("noUiSlider: create requires a single element, got: " + t);
        if (t.noUiSlider)
            throw new Error("noUiSlider: Slider was already initialized.");
        e = r(t, ht(e), e);
        return t.noUiSlider = e
    }
    var L = {
        __spectrum: i,
        cssClasses: u,
        create: z
    };
    et.create = z,
    et.cssClasses = u,
    et.default = L,
    Object.defineProperty(et, "__esModule", {
        value: !0
    })
});
